import React from "react";
import {CardElement} from '@stripe/react-stripe-js';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import momentTz from 'moment-timezone';
import "react-datetime/css/react-datetime.css";
import 'react-toastify/dist/ReactToastify.css';
import AccountIcon from "../../../../../images/icons/account-icon.svg";
import AccountModal from "../../../Components/Main/Sidebar/AccountModal";
import AccountModalHeading from "../../../Components/Main/Sidebar/AccountModalHeading";
import AccountModalInput from "../../../Components/Main/Sidebar/AccountModalInput";
import ModalCheckboxInput from "../../../Components/Main/Sidebar/ModalCheckboxInput";
import AccountModalNote from "../../../Components/Main/Sidebar/AccountModalNote";
import AccountModalSelect from "../../../Components/Main/Sidebar/AccountModalSelect";
import AccountModalSubHeading from "../../../Components/Main/Sidebar/AccountModalSubHeading";
import AnnotationsWrapper from "../../../Components/Main/Sidebar/AnnotationsWrapper";
import ApplauseIcon from "../../../../../images/icons/applause-icon.png";
import AvatarButton from "../../../Components/Main/Sidebar/AvatarButton";
import AvatarImage from "../../../Components/Main/Sidebar/AvatarImage";
import BillingForm from "../../../Components/Main/Sidebar/BillingForm";
import BillingHistoryTableWrapper from "../../../Components/Main/Sidebar/BillingHistoryTableWrapper";
import BillingInput from "../../../Components/Main/Sidebar/BillingInput";
import CancelButton from "../../../Components/Main/Sidebar/CancelButton";
import CheckCircle from "../../../../../images/icons/check-circle.png";
import ChevronRightWhite from "../../../../../images/icons/chevron-right-white.png";
import Clip from "../../../Components/Main/Sidebar/Clip";
import ClipClose from "../../../Components/Main/Sidebar/ClipClose";
import ClipHeading from "../../../Components/Main/Sidebar/ClipHeading";
import ClipMenu from "../../../Components/Main/Sidebar/ClipMenu";
import ClipPlayer from "../../../Components/Main/Sidebar/ClipPlayer";
import ClipVideo from "../../../Components/Main/Sidebar/ClipVideo";
import ClipWrapper from "../../../Components/Main/Sidebar/ClipWrapper";
import ClipsIcon from "../../../../../images/icons/clips-icon.svg";
import ContactUsForm from "../../../Components/Main/Sidebar/ContactUsForm";
import ContactUsFormButton from "../../../Components/Main/Sidebar/ContactUsFormButton";
import ContactUsFormGroup from "../../../Components/Main/Sidebar/ContactUsFormGroup";
import DraggableHeader from "../../../Components/Main/Sidebar/DraggableHeader";
import DraggingIcon from "../../../../../images/icons/dragging-icon.svg";
import ErrorAlert from "../../../Components/Main/Sidebar/ErrorAlert";
import ExperienceRatingBar from "../../../Components/Main/Sidebar/ExperienceRatingBar";
import ExperienceRatingBarLegend from "../../../Components/Main/Sidebar/ExperienceRatingBarLegend";
import ExperienceRatingBarLegendItem from "../../../Components/Main/Sidebar/ExperienceRatingBarLegendItem";
import ExperienceRatingButtons from "../../../Components/Main/Sidebar/ExperienceRatingButtons";
import ExperienceRatingItem from "../../../Components/Main/Sidebar/ExperienceRatingItem";
import ExperienceRatingSubmitButton from "../../../Components/Main/Sidebar/ExperienceRatingSubmitButton";
import ExperienceReview from "../../../Components/Main/Sidebar/ExperienceReview";
import FilesIcon from "../../../../../images/icons/files-icon.svg";
import FilesMenu from "../../../Components/Main/Sidebar/FilesMenu";
import StudentFilesMenu from "../../../Components/Main/Sidebar/StudentFilesMenu";
import StudentFileUploadModal from "../../../Components/Main/Modals/StudentFileUploadModal";
import StudentFileShareModal from "../../../Components/Main/Modals/StudentFileShareModal";
import ForteIcon from "../../../../../images/icons/forte-icon.svg";
import FortisimoIcon from "../../../../../images/icons/fortisimo-icon.svg";
import GeneralNotice from "../../../Components/Main/Sidebar/GeneralNotice";
import GoIcon from "../../../../../images/icons/go-icon.svg";
import Hidden from "../../../Components/Main/Sidebar/Hidden";
import Icon from "../../../Components/Main/Sidebar/Icon";
import IconGroup from "../../../Components/Main/Sidebar/IconGroup";
import IconGroupWrapper from "../../../Components/Main/Sidebar/IconGroupWrapper";
import IconImage from "../../../Components/Main/Sidebar/IconImage";
import IconName from "../../../Components/Main/Sidebar/IconName";
import IconWell from "../../../Components/Main/Sidebar/IconWell";
import MenuClose from "../../../Components/Main/Sidebar/MenuClose";
import Metronome from '../../Metronome'
import MetronomeIcon from "../../../../../images/icons/metronome-icon.svg";
import MetronomePopup from "../../../Components/Main/Sidebar/MetronomePopup";
import MezzoforteIcon from "../../../../../images/icons/mezzoforte-icon.svg";
import MezzopianoIcon from "../../../../../images/icons/mezzopiano-icon.svg";
import Modal from "../../../Components/Main/Modals/Modal";
import ModalButton from "../../../Components/Main/Modals/ModalButton";
import ModalButtonLink from "../../../Components/Main/Sidebar/ModalButtonLink";
import ModalClose from "../../../Components/Main/Sidebar/ModalClose";
import ModalFileInput from "../../../Components/Main/Modals/ModalFileInput";
import ModalHeading from "../../../Components/Main/Modals/ModalHeading";
import ModalInput from "../../../Components/Main/Modals/ModalInput";
import ModalInputWell from "../../../Components/Main/Sidebar/ModalInputWell";
import ModalInfo from "../../../Components/Main/Sidebar/ModalInfo";
import ModalLessonTrigger from "../../../Components/Main/Sidebar/ModalLessonTrigger";
import ModalNote from "../../../Components/Main/Modals/ModalNote";
import ModalOption from "../../../Components/Main/Modals/ModalOption";
import ModalSubheading from "../../../Components/Main/Sidebar/ModalSubheading";
import MoreIcon from "../../../../../images/icons/more-icon.svg";
import MoreMenu from "../../../Components/Main/Sidebar/MoreMenu";
import MoreMenuItem from "../../../Components/Main/Sidebar/MoreMenuItem";
import MultiSelectWrapper from "../../../Components/Main/Sidebar/MultiSelectWrapper";
import MuteIcon from "../../../../../images/icons/mute-icon.svg";
import MuzeDatetime from "../../../Components/Main/MuzeDatetime";
import NewModal from "../../../Components/Main/Sidebar/NewModal";
import NewModalHeading from "../../../Components/Main/Sidebar/NewModalHeading";
import NewModalInput from "../../../Components/Main/Sidebar/NewModalInput";
import NewModalLessonHeading from "../../../Components/Main/Sidebar/NewModalLessonHeading";
import NewModalRecurringSessionEmailInviteInput
    from "../../../Components/Main/Sidebar/NewModalRecurringSessionEmailInviteInput";
import NewModalSelect from "../../../Components/Main/Sidebar/NewModalSelect";
import NewModalTextArea from "../../../Components/Main/Sidebar/NewModalTextArea";
import NotesIcon from "../../../../../images/icons/notes-icon.svg";
import NotesMenu from "../../../Components/Main/Sidebar/NotesMenu";
import ObStep1 from "../../../../../images/ob-steps/ob-step-1.png";
import ObStep10 from "../../../../../images/ob-steps/ob-step-10.png";
import ObStep11 from "../../../../../images/ob-steps/ob-step-11.png";
import ObStep12 from "../../../../../images/ob-steps/ob-step-12.png";
import ObStep13 from "../../../../../images/ob-steps/ob-step-13.png";
import ObStep14 from "../../../../../images/ob-steps/ob-step-14.png";
import ObStep15 from "../../../../../images/ob-steps/ob-step-15.png";
import ObStep16 from "../../../../../images/ob-steps/ob-step-16.png";
import ObStep2 from "../../../../../images/ob-steps/ob-step-2.png";
import ObStep3 from "../../../../../images/ob-steps/ob-step-3.png";
import ObStep4 from "../../../../../images/ob-steps/ob-step-4.png";
import ObStep5 from "../../../../../images/ob-steps/ob-step-5.png";
import ObStep6 from "../../../../../images/ob-steps/ob-step-6.png";
import ObStep7 from "../../../../../images/ob-steps/ob-step-7.png";
import ObStep8 from "../../../../../images/ob-steps/ob-step-8.png";
import ObStep9 from "../../../../../images/ob-steps/ob-step-9.png";
import OnboardingClose from "../../../Components/Main/Sidebar/OnboardingClose";
import OnboardingCloseIcon from "../../../../../images/icons/onboarding-close.png";
import OnboardingCurrentStep from "../../../Components/Main/Sidebar/OnboardingCurrentStep";
import OnboardingDot from "../../../Components/Main/Sidebar/OnboardingDot";
import OnboardingDots from "../../../Components/Main/Sidebar/OnboardingDots";
import OnboardingModal from "../../../Components/Main/Sidebar/OnboardingModal";
import OnboardingModalButtons from "../../../Components/Main/Sidebar/OnboardingModalButtons";
import OnboardingModalImage from "../../../Components/Main/Sidebar/OnboardingModalImage";
import OnboardingModalLeft from "../../../Components/Main/Sidebar/OnboardingModalLeft";
import OnboardingModalNext from "../../../Components/Main/Sidebar/OnboardingModalNext";
import OnboardingModalRight from "../../../Components/Main/Sidebar/OnboardingModalRight";
import OnboardingModalSkip from "../../../Components/Main/Sidebar/OnboardingModalSkip";
import OnboardingModalStep from "../../../Components/Main/Sidebar/OnboardingModalStep";
import OnboardingSteps from "../../../Components/Main/Sidebar/OnboardingSteps";
import OnboardingSuccess from "../../../Components/Main/Sidebar/OnboardingSuccess";
import OnboardingWelcome from "../../../Components/Main/Sidebar/OnboardingWelcome";
import OrangeError from "../../../Components/Main/Sidebar/OrangeError";
import PasswordInput from "../../../Components/Main/Sidebar/PasswordInput";
import PianissimoIcon from "../../../../../images/icons/pianissimo-icon.svg";
import PianoIcon from "../../../../../images/icons/piano-icon.svg";
import Plan from "../../../Components/Main/Sidebar/Plan";
import PlanCheckbox from "../../../Components/Main/Sidebar/PlanCheckbox";
import PlanHeader from "../../../Components/Main/Sidebar/PlanHeader";
import PlanPrice from "../../../Components/Main/Sidebar/PlanPrice";
import PlanPriceMonth from "../../../Components/Main/Sidebar/PlanPriceMonth";
import PopupHeading from "../../../Components/Main/Sidebar/PopupHeading";
import RecordingBar from "../../../Components/Main/Recording/RecordingBar";
import RecordingNotice from "../../../Components/Main/Recording/Notice";
import RecordingNoticeIcon from "../../../Components/Main/Recording/NoticeIcon";
import RecordingNoticeIconImage from "../../../../../images/icons/recording-icon.svg";
import RecurringSessionDaysInput from "../../../Components/Main/Sidebar/RecurringSessionDaysInput";
import NewLessonDescription from "../../../Components/Main/Sidebar/NewLessonDescription";
import NewLessonName from "../../../Components/Main/Sidebar/NewLessonName";
import NewModalSimpleSelect from "../../../Components/Main/Sidebar/NewModalSimpleSelect";
import NewModalSimpleAddButton from "../../../Components/Main/Sidebar/NewModalSimpleAddButton";
import RichTextEditor from 'react-rte';
import RushingIcon from "../../../../../images/icons/rushing-icon.svg";
import SidebarLogo from "../../../Components/Main/Sidebar/SidebarLogo";
import SidebarLogoImg from "../../../Components/Main/Sidebar/SidebarLogoImg";
import SidebarLogoImgSrc from "../../../../../images/sidebar-logo.png";
import SidebarMenu from "../../../Components/Main/Sidebar/SidebarMenu";
import SidebarWrapper from "../../../Components/Main/Sidebar/SidebarWrapper";
import SparklesIcon from "../../../../../images/icons/sparkles-icon.png";
import StopIcon from "../../../../../images/icons/stop-icon.svg";
import StripeInputWrapper from "../../../Components/Main/Sidebar/StripeInputWrapper";
import StudentBubble from "../../../Components/Main/Sidebar/StudentBubble";
import StudentInviteButton from "../../../Components/Main/Sidebar/StudentInviteButton";
import StudentInviteInput from "../../../Components/Main/Sidebar/StudentInviteInput";
import Success from "../../../Components/Main/Sidebar/Success";
import Tab from "../../../Components/Main/Sidebar/Tab";
import TableWrapper from "../../../Components/Main/Sidebar/TableWrapper";
import Tabs from "../../../Components/Main/Sidebar/Tabs";
import Tuner from "../../../Components/Tuner";
import TunerIcon from "../../../../../images/icons/tuner-icon.svg";
import TunerPopup from "../../../Components/Main/Sidebar/TunerPopup";
import VisualCue from "../../../Components/Main/Sidebar/VisualCue";
import VisualCueHeading from "../../../Components/Main/Sidebar/VisualCueHeading";
import VisualCueIcon from "../../../Components/Main/Sidebar/VisualCueIcon";
import VisualCueNotificationText from "../../../Components/Main/Sidebar/VisualCueNotificationText";
import VisualCues from "../../../Components/Main/Sidebar/VisualCues";
import VisualCuesIcon from "../../../../../images/icons/visual-cues-icon.svg";
import VisualCuesPopup from "../../../Components/Main/Sidebar/VisualCuesPopup";
import WellWrapper from "../../../Components/Main/Sidebar/WellWrapper";
import api from '../../../../util/api'
import {MultiSelect} from "react-multi-select-component";
import {toast, ToastContainer} from 'react-toastify';
import {isChrome, isDesktop} from 'react-device-detect';
import {log_out} from '../../../../util/auth';

import {BillingInputSmall, BillingSelect, CallListNote, CallListUser, PlanPriceSuperscript} from './SidebarStyles';

const timezones = moment.tz.names();

export default class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.openCreateNewClip = this.openCreateNewClip.bind(this);
        this.openCreateNewLessonClip = this.openCreateNewLessonClip.bind(this);
        this.openClipAction = this.openClipAction.bind(this);
        this.selectStudent = this.selectStudent.bind(this);
        this.selectSort = this.selectSort.bind(this);
        this.searchMyClips = this.searchMyClips.bind(this);
        this.searchLessonClips = this.searchLessonClips.bind(this);
        this.searchMyNotes = this.searchMyNotes.bind(this);
        this.searchLessonNotes = this.searchLessonNotes.bind(this);
        this.searchMyFiles = this.searchMyFiles.bind(this);
        this.searchLessonFiles = this.searchLessonFiles.bind(this);
        this.toggleRecording = this.toggleRecording.bind(this);
        this.openCreateNewFile = this.openCreateNewFile.bind(this);
        this.openCreateNewLessonFile = this.openCreateNewLessonFile.bind(this);
        this.handleCreateFileNameInputChange = this.handleCreateFileNameInputChange.bind(this);
        this.handleCreateFileSubmit = this.handleCreateFileSubmit.bind(this);
        this.openCreateNewNote = this.openCreateNewNote.bind(this);
        this.openEditNote = this.openEditNote.bind(this);
        this.openViewNote = this.openViewNote.bind(this);
        this.openEditFile = this.openEditFile.bind(this);
        this.openEditClip = this.openEditClip.bind(this);
        this.openCreateNewLessonNote = this.openCreateNewLessonNote.bind(this);
        this.handleCreateClipNameInputChange = this.handleCreateClipNameInputChange.bind(this);
        this.handleChangePasswordInputChange = this.handleChangePasswordInputChange.bind(this);
        this.handleChangeConfirmPasswordInputChange = this.handleChangeConfirmPasswordInputChange.bind(this);
        this.handleStudentInviteInputChange = this.handleStudentInviteInputChange.bind(this);
        this.handleFileInputChange = this.handleFileInputChange.bind(this);
        this.handleCreateClipSubmit = this.handleCreateClipSubmit.bind(this);
        this.handleChangePasswordSubmit = this.handleChangePasswordSubmit.bind(this);
        this.handleStudentInviteSubmit = this.handleStudentInviteSubmit.bind(this);
        this.cancelInvite = this.cancelInvite.bind(this);
        this.handleChangeNameSubmit = this.handleChangeNameSubmit.bind(this);
        this.handleAccountFormSubmit = this.handleAccountFormSubmit.bind(this);
        this.handleChangeEmailSubmit = this.handleChangeEmailSubmit.bind(this);
        this.handleCreateNoteNameInputChange = this.handleCreateNoteNameInputChange.bind(this);
        this.handleEditNoteNameInputChange = this.handleEditNoteNameInputChange.bind(this);
        this.handleEditClipNameInputChange = this.handleEditClipNameInputChange.bind(this);
        this.handleEditFileNameInputChange = this.handleEditFileNameInputChange.bind(this);
        this.handleEditNoteContentInputChange = this.handleEditNoteContentInputChange.bind(this);
        this.handleCreateSessionStudentInputChange = this.handleCreateSessionStudentInputChange.bind(this);
        this.handleCreateSessionStudentIdsInputChange = this.handleCreateSessionStudentIdsInputChange.bind(this);
        this.handleRecurringSessionCheckboxChange = this.handleRecurringSessionCheckboxChange.bind(this);
        this.handleRecurringSessionTypeChange = this.handleRecurringSessionTypeChange.bind(this);
        this.handleRecurringSessionDaysInputChange = this.handleRecurringSessionDaysInputChange.bind(this);
        this.handleLessonDescriptionInputChange = this.handleLessonDescriptionInputChange.bind(this);
        this.handleRecurringSessionEmailInviteInputChange = this.handleRecurringSessionEmailInviteInputChange.bind(this);
        this.handleCreateSessionStudentDatetimeInputChange = this.handleCreateSessionStudentDatetimeInputChange.bind(this);
        this.handleCreateSessionStudentDatetimeInputClose = this.handleCreateSessionStudentDatetimeInputClose.bind(this);
        this.handleCreateNoteContentInputChange = this.handleCreateNoteContentInputChange.bind(this);
        this.handleCreateNoteSubmit = this.handleCreateNoteSubmit.bind(this);
        this.handleEditNoteSubmit = this.handleEditNoteSubmit.bind(this);
        this.autoSaveNoteDraft = this.autoSaveNoteDraft.bind(this);
        this.restoreNoteDraft = this.restoreNoteDraft.bind(this);
        this.dismissNoteDraft = this.dismissNoteDraft.bind(this);
        this.autoSaveEditNote = this.autoSaveEditNote.bind(this);
        this.handleEditClipSubmit = this.handleEditClipSubmit.bind(this);
        this.handleEditFileSubmit = this.handleEditFileSubmit.bind(this);
        this.handleCreateSessionSubmit = this.handleCreateSessionSubmit.bind(this);
        this.handleTimezoneSubmit = this.handleTimezoneSubmit.bind(this);
        this.state = {
            active_subscription: false,
            edit_name: '',
            edit_email: '',
            edit_timezone: '',
            contact_us_first_name: '',
            contact_us_last_name: '',
            contact_us_email: '',
            contact_us_reason: '',
            contact_us_message: '',
            contact_us_device: '',
            review_session_uuid: null,
            selected_rating: null,
            review_comments: null,
            review_features: null,
            onboarding_step: null,
            open_menu: null,
            modal_open: null,
            clip_name: "",
            file_input: "",
            file_input_val: "",
            note_content: RichTextEditor.createEmptyValue(),
            note_name: '',
            note_draft_available: false,
            note_minimized: false,
            edit_note_save_status: null,
            yourNotes: [],
            lessonNotes: [],
            yourClips: [],
            students: [],
            lessonClips: [],
            file_name: "",
            yourFiles: [],
            lessonFiles: [],
            recording_pre: false,
            recording_now: false,
            recording_notice: "Recording Starting in 3...",
            rec_seconds: 0,
            recording_time: "00:00",
            recording_paused: false,
            in_lesson: this.props.in_lesson && this.props.lesson_id ? this.props.in_lesson : false,
            archive_id: null,
            clip_timeout: null,
            notice_text: '',
            has_notice: false,
            show_subscription: false,
            has_error: false,
            annotations_open: false,
            clip_player_url: '',
            clip_player_name: '',
            clip_player_id: null,
            last_current_time: null,
            student_id: '',
            student_ids: [],
            session_datetime: null,
            // Bumped after each successful create to force the datetime picker to
            // remount. react-datetime keeps its last date in the input even when the
            // controlled value is cleared, so without a fresh mount the next lesson's
            // field still shows the previous date while the bound state is null.
            session_form_key: 0,
            recurring_session_checkbox: false,
            recurring_session_type: '',
            recurring_session_occurrences: '',
            recurring_session_email_invite: '',
            lesson_description: null,
            lesson_name: null,
            my_clips_search: null,
            lesson_clips_search: null,
            my_notes_search: null,
            lesson_notes_search: null,
            my_files_search: null,
            lesson_files_search: null,
            my_clips_student_id: null,
            lesson_clips_student_id: null,
            my_notes_student_id: null,
            lesson_notes_student_id: null,
            my_files_student_id: null,
            lesson_files_student_id: null,
            show_recording_button: true,
            change_password: '',
            change_confirm_password: '',
            session_saving: false,
            session_deleting: false,
            timezone: null,
            session_creation_error: null,
            file_creation_error: null,
            edit_note_id: null,
            edit_note_name: '',
            edit_clip_name: '',
            edit_clip_id: null,
            edit_note_content: RichTextEditor.createEmptyValue(),
            view_note_content: '',
            note_content_for_form: null,
            edit_note_content_for_form: null,
            files_meta: null,
            student_files_meta: null,
            clips_meta: null,
            student_clips_meta: null,
            notes_meta: null,
            student_notes_meta: null,
            student_options: [],
            pending_invites: [],
            selectedNoteStudents: [],
            selectedClipStudents: [],
            selectedFileStudents: [],
            selectedEditNoteStudents: [],
            selectedEditClipStudents: [],
            selectedEditFileStudents: [],
            my_clips_sort: 'created_at',
            lesson_clips_sort: 'created_at',
            my_files_sort: 'created_at',
            lesson_files_sort: 'created_at',
            my_notes_sort: 'created_at',
            lesson_notes_sort: 'created_at',
            account_form_error: null,
            account_form_success: null,
            student_invite_form_error: null,
            student_invite_form_success: null,
            password_form_error: null,
            password_form_success: null,
            student_invite_email: '',
            subscription_info: null,
            billingCity: '',
            billingAddress: '',
            billingState: '',
            billingName: '',
            selectedPlan: 'yearly',
            billingFormError: '',
            clipsLoading: false,
            filesLoading: false,
            notesLoading: false,
            session_datetime_open: false,
            is_tablet: false,
            chrome_modal_open: false,
            share_heading: false,
            created_session_datetime: null,
            created_session_name: null,
            created_session_description: null,
            created_repeat: null,
            created_student_id: null,
            deleted_session_datetime: null,
            deleted_session_name: null,
            deleted_session_description: null,
            deleted_repeat: null,
            deleted_student_id: null,
            user_timezone: "UTC",
            timezone_modal_open: false,
            studentInstructors: [],
            studentUploadOpen: false,
            studentShareOpen: false,
            studentShareFileId: null,
            delete_all_recurring: false
        };
    }

    componentDidMount() {
        this.setState({timezone: momentTz.tz.guess()});
        if (!isChrome && isDesktop) {
            this.setState({chrome_modal_open: true});
        }
        var loggedInUser = null;
        api().get('/user')
            .then((response) => {
                loggedInUser = response.data;
                var show_subscription = loggedInUser && loggedInUser.is_instructor && loggedInUser.stripe_id !== null;
                this.setState({
                    edit_name: loggedInUser.name,
                    edit_student_name: loggedInUser.student_name,
                    edit_email: loggedInUser.email,
                    edit_timezone: loggedInUser.timezone,
                    show_subscription: show_subscription,
                    user_timezone: loggedInUser.timezone,
                });
                if (!loggedInUser.has_selected_timezone) {
                    this.setState({timezone_modal_open: true});
                }
                if (show_subscription) {
                    api().get('/user-plan')
                        .then((response) => {
                            this.setState({
                                subscription_info: response.data
                            });
                        });
                }
                this.setState({
                    active_subscription: loggedInUser.can_access_platform
                });
                var sessionId = this.findGetParameter('review_session_uuid');
                if (sessionId) {
                    api().get('/session/' + sessionId + '/review').then((reponse) => {
                        if (reponse.data.data.length == 0) {
                            this.setState({review_session_uuid: sessionId, onboarding_step: 18});
                        }
                    });
                }
                var cancel_alert = this.findGetParameter('cancel');
                var resume_alert = this.findGetParameter('resume');
                if (cancel_alert) {
                    this.setOpenMenu(10);
                    toast.success('Success! Subscription canceled!', {
                        position: "top-right", autoClose: 5000, hideProgressBar: true, closeOnClick: true,
                    });
                }
                if (resume_alert) {
                    this.setOpenMenu(10);
                    toast.success('Success! Subscription resumed!', {
                        position: "top-right", autoClose: 5000, hideProgressBar: true, closeOnClick: true,
                    });
                }
                if (loggedInUser.is_instructor) {
                    this.pullStudents();
                } else {
                    this.pullInstructors();
                }
                if (!loggedInUser.onboarded) {
                    api().get('/user-onboarded');
                    this.setState({review_session_uuid: sessionId, onboarding_step: 19});
                }
                if (this.props.lesson_id) {

                    Echo.channel(`session.${this.props.lesson_id}`)
                        .listen('ClipStatus', (e) => {
                            if (loggedInUser && e && e.user_id !== loggedInUser.id) {
                                // Applying a remote clip state below (play/pause/seek/close)
                                // fires this <video>'s own onPlay/onPause/onSeeking handlers,
                                // which would re-broadcast ClipStatus and create an endless
                                // play/pause ping-pong between participants. Suppress our own
                                // broadcasts briefly while we apply the incoming remote state.
                                this.suppressClipBroadcastUntil = Date.now() + 1000;
                                if (e.status === 'playing') {
                                    if (this.state.annotations_open) {
                                        this.refs.videoPlayer.play();
                                    } else {
                                        this.setState({
                                            annotations_open: true,
                                            open_menu: null,
                                            clip_player_url: e.clip.path,
                                            clip_player_name: e.clip.name,
                                            clip_player_id: e.clip.id
                                        });
                                        this.refs.videoPlayer.muted = true;
                                        this.refs.videoPlayer.play();
                                    }
                                }
                                if (e.status === 'paused' && this.state.annotations_open) {
                                    this.refs.videoPlayer.pause();
                                }
                                if (e.status === 'stop' && this.state.annotations_open) {
                                    // Remote-initiated close: don't re-broadcast /stop.
                                    this.closeClipAction(false);
                                }
                                if (e.status === 'seek') {
                                    if (this.state.last_current_time !== e.current_time) {
                                        this.refs.videoPlayer.currentTime = e.current_time;
                                    }
                                }
                            }
                        })
                        .listen('VisualCue', e => {
                            if (this.state.open_menu === 5) {
                                this.setOpenMenu(null);
                            }
                            toast(() => (<><VisualCueIcon
                                src={e.cue}/><VisualCueNotificationText>{e.cue_text}</VisualCueNotificationText></>), {
                                position: toast.POSITION.BOTTOM_CENTER
                            });
                        })
                        .listen('PullClips', e => {
                            this.pullClips();
                            this.pullClips(true);
                        })
                        .listen('PullFiles', e => {
                            this.pullFiles();
                            this.pullFiles(true);
                        })
                        .listen('PullNotes', e => {
                            this.pullNotes();
                            this.pullNotes(true);
                        })
                        .listen('StartCountdown', e => {
                            if (loggedInUser && e.user_id !== loggedInUser.id) {
                                this.setState({
                                    modal_open: null, recording_pre: true, rec_seconds: 0, recording_time: '00:00'
                                });
                                var component = this;
                                setTimeout(function () {
                                    component.setState({
                                        recording_notice: "Recording Starting in 2...",
                                    });
                                    setTimeout(function () {
                                        component.setState({
                                            recording_notice: "Recording Starting in 1...",
                                        });
                                        setTimeout(function () {
                                            component.setState({
                                                recording_now: true,
                                                show_recording_button: false,
                                                recording_pre: false,
                                                clip_name: '',
                                                rec_seconds: 0,
                                                recording_time: '00:00'
                                            });

                                            // Guard against a duplicate interval: the recorder can hit
                                            // both this echo path and the local path, doubling the counter.
                                            if (component.state.clip_timeout) {
                                                clearInterval(component.state.clip_timeout);
                                            }
                                            var clip_timeout = setInterval(function () {
                                                component.setTime();
                                            }, 1000);
                                            component.setState({
                                                clip_timeout: clip_timeout
                                            });
                                        }, 1000);
                                    }, 1000);
                                }, 1000);
                            }
                        })
                        .listen('StopRecording', e => {
                            if (this.state.clip_timeout) {
                                clearInterval(this.state.clip_timeout);
                            }
                            this.setState({
                                recording_now: false,
                                show_recording_button: true,
                                rec_seconds: 0,
                                recording_time: '00:00',
                                recording_notice: "Recording Starting in 3..."
                            });
                        });
                } else {
                    if (loggedInUser) {

                        Echo.channel(`user.${loggedInUser.id}`)
                            .listen('PullLessons', e => {
                                this.props.fetchLessons();
                            });
                    }
                }
            });

        this.pullNotes();
        this.pullFiles();
        this.pullClips();

        this.pullFiles(true);
        this.pullNotes(true);
        this.pullClips(true);

        var full = this.findGetParameter('full');
        if (full) {
            this.openCreateNewClip();
        }


        if (!this.props.isInstructor) {
            api().get('/students/my-instructors').then((res) => {
                this.setState({ studentInstructors: res.data.data || [] });
            });
        }

        dragElement(document.getElementById("note-modal"));
        dragElement(document.getElementById("file-modal"));
        dragElement(document.getElementById("clip-modal"));
        dragElement(document.getElementById("lesson-modal"));
        dragElement(document.getElementById("note-edit-modal"));

        function dragElement(elmnt) {
            var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
            if (document.getElementById(elmnt.id + "-header")) {
                /* if present, the header is where you move the DIV from:*/
                document.getElementById(elmnt.id + "-header").onmousedown = dragMouseDown;
            } else {
                /* otherwise, move the DIV from anywhere inside the DIV:*/
                elmnt.onmousedown = dragMouseDown;
            }

            function dragMouseDown(e) {
                e = e || window.event;
                e.preventDefault();
                pos3 = e.clientX;
                pos4 = e.clientY;
                document.onmouseup = closeDragElement;
                document.onmousemove = elementDrag;
            }

            function elementDrag(e) {
                e = e || window.event;
                e.preventDefault();
                pos1 = pos3 - e.clientX;
                pos2 = pos4 - e.clientY;
                pos3 = e.clientX;
                pos4 = e.clientY;

                var newTop = elmnt.offsetTop - pos2;
                var newLeft = elmnt.offsetLeft - pos1;

                /* On-screen clamp: keep at least MARGIN px of the box within the
                   viewport on each axis so a dragged box (incl. a minimized note)
                   can never be lost off-screen. These modals are centered via
                   transform: translate(-50%, -50%), so offsetTop/Left sit half a
                   box ahead of the visual top-left — the half_w/half_h terms
                   convert the visual bounds back into offset coordinates. */
                var MARGIN = 60;
                var half_w = elmnt.offsetWidth / 2;
                var half_h = elmnt.offsetHeight / 2;
                var minLeft = MARGIN - half_w;
                var maxLeft = window.innerWidth - MARGIN + half_w;
                var minTop = half_h;
                var maxTop = window.innerHeight - MARGIN + half_h;

                if (newLeft < minLeft) newLeft = minLeft;
                if (newLeft > maxLeft) newLeft = maxLeft;
                if (newTop < minTop) newTop = minTop;
                if (newTop > maxTop) newTop = maxTop;

                elmnt.style.top = newTop + "px";
                elmnt.style.left = newLeft + "px";
            }

            function closeDragElement() {
                document.onmouseup = null;
                document.onmousemove = null;
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isInstructor !== this.props.isInstructor && this.props.isInstructor === false) {
            api().get('/students/my-instructors').then((res) => {
                this.setState({ studentInstructors: res.data.data || [] });
            });
        }
    }

    handleCreateNoteNameInputChange(event) {
        this.setState({note_name: event.target.value}, this.autoSaveNoteDraft);
    }

    handleEditNoteNameInputChange(event) {
        this.setState({edit_note_name: event.target.value}, this.autoSaveEditNote);
    }

    handleEditClipNameInputChange(event) {
        this.setState({edit_clip_name: event.target.value});
    }

    handleEditFileNameInputChange(event) {
        this.setState({edit_file_name: event.target.value});
    }

    handleCreateSessionStudentInputChange(event) {
        this.setState({student_id: event.target.value})
    }

    handleCreateSessionStudentIdsInputChange(value) {
        this.setState({student_ids: value})
    }

    handleRecurringSessionCheckboxChange(event) {
        this.setState({recurring_session_checkbox: !this.state.recurring_session_checkbox});
    }

    handleRecurringSessionTypeChange(event) {
        this.setState({recurring_session_type: event.target.value})
    }

    handleRecurringSessionDaysInputChange(event) {
        this.setState({recurring_session_occurrences: event.target.value})
    }

    handleLessonDescriptionInputChange(event) {
        this.setState({lesson_description: event.target.value})
    }

    handleRecurringSessionEmailInviteInputChange(event) {
        this.setState({recurring_session_email_invite: event.target.value});
    }

    handleCreateSessionStudentDatetimeInputChange(value) {
        this.setState({
            session_datetime: value, session_datetime_open: true
        });
    }

    handleCreateSessionStudentDatetimeInputClose(value) {
        this.setState({session_datetime: value, session_datetime_open: false});
    }

    handleCreateClipNameInputChange(event) {
        this.setState({clip_name: event.target.value});
    }

    handleChangePasswordInputChange(event) {
        this.setState({change_password: event.target.value});
    }

    handleChangeConfirmPasswordInputChange(event) {
        this.setState({change_confirm_password: event.target.value});
    }

    handleStudentInviteInputChange(event) {
        this.setState({student_invite_email: event.target.value});
    }


    handleCreateNoteContentInputChange(event) {
        this.setState({note_content: event, note_content_for_form: event.toString('html')}, this.autoSaveNoteDraft);
    }

    handleEditNoteContentInputChange(event) {
        this.setState({edit_note_content: event, edit_note_content_for_form: event.toString('html')}, this.autoSaveEditNote);
    }

    autoSaveNoteDraft() {
        clearTimeout(this._newNoteDraftTimer);
        this._newNoteDraftTimer = setTimeout(() => {
            const name = this.state.note_name || '';
            const content = this.state.note_content_for_form || '';
            if (name || content) {
                localStorage.setItem('muze_note_draft', JSON.stringify({ name, content_html: content, timestamp: Date.now() }));
            }
        }, 800);
    }

    restoreNoteDraft() {
        const raw = localStorage.getItem('muze_note_draft');
        if (!raw) return;
        try {
            const draft = JSON.parse(raw);
            if (draft.name || draft.content_html) {
                this.setState({
                    note_name: draft.name || '',
                    note_content: RichTextEditor.createValueFromString(draft.content_html || '', 'html'),
                    note_content_for_form: draft.content_html || '',
                    note_draft_available: true,
                });
            }
        } catch (e) {}
    }

    dismissNoteDraft() {
        localStorage.removeItem('muze_note_draft');
        this.setState({ note_draft_available: false });
    }

    autoSaveEditNote() {
        if (!this.state.edit_note_id) return;
        clearTimeout(this._editNoteAutoSaveTimer);
        this._editNoteAutoSaveTimer = setTimeout(() => {
            if (!this.state.edit_note_id) return;
            this.setState({ edit_note_save_status: 'saving' });
            api().put('notes/' + this.state.edit_note_id, {
                name: this.state.edit_note_name,
                content: this.state.edit_note_content_for_form,
                extra_user_ids: this.state.selectedEditNoteStudents
            }).then(() => {
                this.setState({ edit_note_save_status: 'saved' });
            }).catch(() => {
                this.setState({ edit_note_save_status: 'error' });
            });
        }, 1500);
    }

    handleCreateFileNameInputChange(event) {
        this.setState({file_name: event.target.value});
    }

    handleFileInputChange(e) {
        this.setState({
            file_input: e.target.files[0], file_name: e.target.files[0].name,
        });
    }

    setOpenMenu(val) {
        this.setState({
            open_menu: val, modal_open: null,
        });
    }

    openCreateNewNote() {
        this.setState({
            open_menu: null, modal_open: "note", note_draft_available: false, note_minimized: false,
        }, this.restoreNoteDraft);
    }

    toggleNoteMinimized = () => {
        this.setState({note_minimized: !this.state.note_minimized});
    }

    // Pin / unpin a note (toggles the shared `favorite` flag). Pinned notes sort
    // to the top of the list, so refresh both note lists to reflect the new order.
    toggleNotePin = (id) => {
        api().get('/notes/' + id + '/toggleFavorite').then(() => {
            this.pullNotes();
            this.pullNotes(true);
        }).catch(() => {});
    }

    // Open note hyperlinks in a new tab, and only for safe schemes. The read-only
    // view renders links via Draft's decorator (which navigates in-place and may
    // carry an unsanitized href); intercepting at the container guarantees new-tab
    // behavior and blocks javascript:/data: links from ever navigating/executing.
    handleNoteLinkClick = (event) => {
        const anchor = event.target && event.target.closest ? event.target.closest('a') : null;
        if (!anchor) {
            return;
        }
        event.preventDefault();
        const safe = ['http:', 'https:', 'mailto:'].indexOf(anchor.protocol) !== -1;
        if (safe) {
            window.open(anchor.href, '_blank', 'noopener,noreferrer');
        }
    }

    openEditNote(val) {
        var selectedEditNoteStudents = [];
        this.setState({
            view_note: false,
            edit_note_name: '',
            edit_note_content: RichTextEditor.createEmptyValue(),
            selectedEditNoteStudents: [],
            edit_note_save_status: null,
        });
        api().get('/notes/' + val)
            .then((response) => {
                (response.data.data.shared_users || []).forEach(element => {
                    selectedEditNoteStudents.push({
                        label: element.name, value: element.id
                    });
                });
                this.setState({
                    view_note: false,
                    open_menu: null,
                    modal_open: "note-edit",
                    note_minimized: false,
                    edit_note_id: val,
                    edit_note_name: response.data.data.name,
                    edit_note_content: RichTextEditor.createValueFromString(response.data.data.content, 'html'),
                    edit_note_content_for_form: RichTextEditor.createValueFromString(response.data.data.content, 'html').toString('html'),
                    selectedEditNoteStudents: selectedEditNoteStudents
                });
            });
    }

    openViewNote(val) {
        var selectedEditNoteStudents = [];
        this.setState({
            view_note: true,
            edit_note_name: '',
            edit_note_content: RichTextEditor.createEmptyValue(),
            selectedEditNoteStudents: []
        });

        api().get('/notes/' + val)
            .then((response) => {
                this.setState({
                    view_note: true,
                    open_menu: null,
                    modal_open: "note-edit",
                    note_minimized: false,
                    edit_note_id: val,
                    edit_note_name: response.data.data.name,
                    edit_note_content: RichTextEditor.createValueFromString(response.data.data.content, 'html'),
                    selectedEditNoteStudents: selectedEditNoteStudents
                });
            });
    }

    openEditFile(val, share_heading = false) {
        var selectedEditFileStudents = [];
        this.setState({
            edit_file_name: null, selectedEditFileStudents: [], share_heading: share_heading
        });

        api().get('/files/' + val)
            .then((response) => {
                (response.data.data.shared_users || []).forEach(element => {
                    selectedEditFileStudents.push({
                        label: element.name, value: element.id
                    });
                });
                this.setState({
                    open_menu: null,
                    modal_open: "file-edit",
                    edit_file_id: val,
                    edit_file_name: response.data.data.name,
                    selectedEditFileStudents: selectedEditFileStudents
                });
            });
    }

    openEditClip(val) {
        var selectedEditClipStudents = [];
        this.setState({
            edit_clip_name: null, selectedEditClipStudents: []
        });
        api().get('/clips/' + val)
            .then((response) => {
                (response.data.data.shared_users || []).forEach(element => {
                    selectedEditClipStudents.push({
                        label: element.name, value: element.id
                    });
                });
                this.setState({
                    open_menu: null,
                    modal_open: "clip-edit",
                    edit_clip_id: val,
                    edit_clip_name: response.data.data.name,
                    selectedEditClipStudents: selectedEditClipStudents
                });
            });

    }

    openCreateNewLessonNote() {
        this.setState({
            open_menu: null, modal_open: "lesson_note", note_draft_available: false, note_minimized: false,
        }, this.restoreNoteDraft);
    }

    openCreateNewFile() {
        this.setState({
            open_menu: null, modal_open: "file",
        });
    }

    openCreateNewLessonFile() {
        this.setState({
            open_menu: null, modal_open: "lesson_file",
        });
    }

    openCreateNewLessonClip() {
        this.setState({
            open_menu: null, modal_open: "lesson_clip",
        });
    }

    openClipAction(clip) {
        this.setState({
            clip_player_url: null,
        }, () => {
            this.setState({
                annotations_open: true,
                open_menu: null,
                clip_player_url: clip.path,
                clip_player_name: clip.name,
                clip_player_id: clip.id
            });
        });
    }

    searchMyClips(e) {
        if (e.key == 'Enter' || e.target.value == '') {
            this.setState({
                my_clips_search: e.target.value
            }, () => {
                this.pullClips();
            });
        }
    }

    selectStudent(e, type) {
        if (type == 'myClips') {
            this.setState({my_clips_student_id: e.target.value}, () => {
                this.pullClips();
            });
        }
        if (type == 'lessonClips') {
            this.setState({lesson_clips_student_id: e.target.value}, () => {
                this.pullClips(true);
            });
        }
        if (type == 'myNotes') {
            this.setState({my_notes_student_id: e.target.value}, () => {
                this.pullNotes();
            });
        }
        if (type == 'lessonNotes') {
            this.setState({lesson_notes_student_id: e.target.value}, () => {
                this.pullNotes(true);
            });
        }
        if (type == 'myFiles') {
            this.setState({my_files_student_id: e.target.value}, () => {
                this.pullFiles();
            });
        }
        if (type == 'lessonFiles') {
            this.setState({lesson_files_student_id: e.target.value}, () => {
                this.pullFiles(true);
            });
        }
    }

    selectSort(e, type) {
        if (type == 'myClips') {
            this.setState({my_clips_sort: e.target.value, clipsLoading: true}, () => {
                this.pullClips();
            });
        }
        if (type == 'lessonClips') {
            this.setState({lesson_clips_sort: e.target.value, clipsLoading: true}, () => {
                this.pullClips(true);
            });
        }
        if (type == 'myNotes') {
            this.setState({my_notes_sort: e.target.value, notesLoading: true}, () => {
                this.pullNotes();
            });
        }
        if (type == 'lessonNotes') {
            this.setState({lesson_notes_sort: e.target.value, notesLoading: true}, () => {
                this.pullNotes(true);
            });
        }
        if (type == 'myFiles') {
            this.setState({my_files_sort: e.target.value, filesLoading: true}, () => {
                this.pullFiles();
            });
        }
        if (type == 'lessonFiles') {
            this.setState({lesson_files_sort: e.target.value, filesLoading: true}, () => {
                this.pullFiles(true);
            });
        }
    }

    searchLessonClips(e) {
        if (e.key == 'Enter' || e.target.value == '') {
            this.setState({
                lesson_clips_search: e.target.value, clipsLoading: true
            }, () => {
                this.pullClips(true);
            });
        }
    }

    searchMyNotes(e) {
        if (e.key == 'Enter' || e.target.value == '') {
            this.setState({
                my_notes_search: e.target.value, notesLoading: true
            }, () => {
                this.pullNotes();
            });
        }
    }

    searchLessonNotes(e) {
        if (e.key == 'Enter' || e.target.value == '') {
            this.setState({
                lesson_notes_search: e.target.value, notesLoading: true
            }, () => {
                this.pullNotes(true);
            });
        }
    }

    searchMyFiles(e) {
        if (e.key == 'Enter' || e.target.value == '') {
            this.setState({
                my_files_search: e.target.value
            }, () => {
                this.pullFiles();
            });
        }
    }

    searchLessonFiles(e) {
        if (e.key == 'Enter' || e.target.value == '') {
            this.setState({
                lesson_files_search: e.target.value
            }, () => {
                this.pullFiles(true);
            });
        }
    }

    closeClipAction(broadcast = true) {
        // broadcast=false when this close was triggered by a remote /stop, so we
        // don't echo it back and sustain the play/pause loop.
        if (broadcast && this.props.lesson_id && this.state.clip_player_id) {
            api().get("session/" + this.props.lesson_id + "/clips/" + this.state.clip_player_id + "/stop");
        }
        this.setState({
            annotations_open: false, clip_player_url: null, clip_player_name: null, clip_player_id: null
        });
        this.refs.videoPlayer.pause();
    }

    openCreateNewClip() {
        this.setState({
            open_menu: null, modal_open: "clip",
        });
    }

    constructClipsApiURL(is_lesson, page) {
        let clipsApiURL = is_lesson && this.props.lesson_id ? "session/" + this.props.lesson_id + "/clips" : "clips";
        let firstParam = true;
            if (page) {
                clipsApiURL += '?page=' + page;
                firstParam = false;
            }

        let delimiter = '';

        if (is_lesson && this.state.lesson_clips_search) {
                clipsApiURL += '?q=' + this.state.lesson_clips_search;
                firstParam = false;
            }
        if (is_lesson && this.state.lesson_clips_student_id) {
                delimiter = firstParam ? '?' : '&';
                clipsApiURL += delimiter + 'student_id=' + this.state.lesson_clips_student_id;
            firstParam = false;
            }
        if (is_lesson && this.state.lesson_clips_sort) {
                delimiter = firstParam ? '?' : '&';
                clipsApiURL += delimiter + 'sort=' + this.state.lesson_clips_sort;
            }
        if (!is_lesson && this.state.my_clips_search) {
                clipsApiURL += '?q=' + this.state.my_clips_search;
                firstParam = false;
            }
        if (!is_lesson && this.state.my_clips_student_id) {
                delimiter = firstParam ? '?' : '&';
                clipsApiURL += delimiter + 'student_id=' + this.state.my_clips_student_id;
            firstParam = false;
            }
        if (!is_lesson && this.state.my_clips_sort) {
                delimiter = firstParam ? '?' : '&';
                clipsApiURL += delimiter + 'sort=' + this.state.my_clips_sort;
            }

        return clipsApiURL;
    }

    pullClips(is_lesson = false, page = null) {
        this.setState({clipsLoading: false}, () => {
            const clipsApiURL = this.constructClipsApiURL(is_lesson, page);

            api().get(clipsApiURL)
                .then(({ data } = {}) => {
                    const meta  = data?.meta ?? null;
                    const clips = data?.data ?? null;

                    if (is_lesson) {
                        this.setState({ student_clips_meta: meta, lessonClips: clips });
                    } else {
                        this.setState({ clips_meta: meta, yourClips: clips });
                    }
                })
                .catch(() => {
                    if (is_lesson) {
                        this.setState({ student_clips_meta: null, lessonClips: null });
                    } else {
                        this.setState({ clips_meta: null, yourClips: null });
                    }
                })
                .finally(() => this.setState({ clipsLoading: false }));
        });
    }

    constructNotesApiURL(is_lesson, page) {
        let notesApiURL = is_lesson && this.props.lesson_id ? "session/" + this.props.lesson_id + "/notes" : "/notes";
        let firstParam = true;
            if (page) {
                notesApiURL += '?page=' + page;
                firstParam = false;
            }

        let delimiter = '';

        if (is_lesson && this.state.lesson_notes_search) {
                notesApiURL += '?q=' + this.state.lesson_notes_search;
                firstParam = false;
            }
        if (is_lesson && this.state.lesson_notes_student_id) {
                delimiter = firstParam ? '?' : '&';
                notesApiURL += delimiter + 'student_id=' + this.state.lesson_notes_student_id;
            firstParam = false;
            }
        if (is_lesson && this.state.lesson_notes_sort) {
                delimiter = firstParam ? '?' : '&';
                notesApiURL += delimiter + 'sort=' + this.state.lesson_notes_sort;
            }
        if (!is_lesson && this.state.my_notes_search) {
                notesApiURL += '?q=' + this.state.my_notes_search;
                firstParam = false;
            }
        if (!is_lesson && this.state.my_notes_student_id) {
                delimiter = firstParam ? '?' : '&';
                notesApiURL += delimiter + 'student_id=' + this.state.my_notes_student_id;
            firstParam = false;
            }
        if (!is_lesson && this.state.my_notes_sort) {
                delimiter = firstParam ? '?' : '&';
                notesApiURL += delimiter + 'sort=' + this.state.my_notes_sort;
            }

        return notesApiURL;
    }

    pullNotes(is_lesson = false, page = null) {
        this.setState({notesLoading: false}, () => {
            const notesApiURL = this.constructNotesApiURL(is_lesson, page);

            api().get(notesApiURL)
                .then((response) => {
                    if (is_lesson) {
                        this.setState({
                            student_notes_meta: response.data.meta ? response.data.meta : null,
                            lessonNotes: response.data.data ? response.data.data : null,
                        notesLoading: false
                        });
                    } else {
                        this.setState({
                            notes_meta: response.data.meta ? response.data.meta : null,
                            yourNotes: response.data.data ? response.data.data : null,
                        notesLoading: false
                        });
                    }
                });
        });
    }

    pullStudents() {
        api().get("/students")
            .then((response) => {
                this.setState({students: response.data.data});
                var students = [];
                var selected_students = [];
                (response.data.data || []).forEach((item) => {
                    students.push({
                        label: item.name, value: item.id
                    });

                    if (this.props.lesson) {
                        if (this.props.lesson.student_id == item.student.id) {

                            selected_students.push({
                                label: item.name, value: item.id
                            });
                        }
                    }
                });
                if (this.props.isInstructor) {
                    this.setState({
                        student_options: students,
                        selectedNoteStudents: selected_students,
                        selectedClipStudents: selected_students,
                        selectedFileStudents: selected_students
                    });
                }
            });
        if (this.props.isInstructor) {
            api().get("/students/pending-invites")
                .then((response) => {
                    this.setState({pending_invites: response.data.data});
                });
        }
    }

    removeStudent(studentId) {
        if (!window.confirm('Are you sure you want to remove this student?')) {
            return;
        }
        api().delete(`/students/${studentId}`)
            .then(() => {
                this.pullStudents();
            })
            .catch((error) => {
                console.error('Error removing student:', error);
            });
    }

    pullInstructors() {
        api().get("/instructors")
            .then((response) => {
                var students = [];
                var selected_students = [];
                (response.data.data || []).forEach((item) => {
                    students.push({
                        label: item.name, value: item.id
                    });

                    if (this.props.lesson) {
                        if (this.props.lesson.instructor_id == item.instructor.id) {
                            selected_students.push({
                                label: item.name, value: item.id
                            });
                        }
                    }
                });
                if (!this.props.isInstructor) {
                    this.setState({
                        student_options: students,
                        selectedNoteStudents: selected_students,
                        selectedClipStudents: selected_students,
                        selectedFileStudents: selected_students
                    });
                }
            });
    }

    pullFiles(is_lesson = false, page = null) {
        this.setState({filesLoading: true}, () => {
            var filesApiURL = is_lesson && this.props.lesson_id ? "session/" + this.props.lesson_id + "/files" : "files";

            var firstParam = true;
            if (page) {
                filesApiURL += '?page=' + page;
                firstParam = false;
            }
            var delimiter = '';
            if (is_lesson && this.state.lesson_files_search != '' && this.state.lesson_files_search != null) {
                filesApiURL += '?q=' + this.state.lesson_files_search;
                firstParam = false;
            }
            if (is_lesson && this.state.lesson_files_student_id != '' && this.state.lesson_files_student_id != null) {
                delimiter = firstParam ? '?' : '&';
                filesApiURL += delimiter + 'student_id=' + this.state.lesson_files_student_id;
            }
            if (is_lesson && this.state.lesson_files_sort != '') {
                delimiter = firstParam ? '?' : '&';
                filesApiURL += delimiter + 'sort=' + this.state.lesson_files_sort;
            }
            if (!is_lesson && this.state.my_files_search != '' && this.state.my_files_search != null) {
                filesApiURL += '?q=' + this.state.my_files_search;
                firstParam = false;
            }
            if (!is_lesson && this.state.my_files_student_id != '' && this.state.my_files_student_id != null) {
                delimiter = firstParam ? '?' : '&';
                filesApiURL += delimiter + 'student_id=' + this.state.my_files_student_id;
            }
            if (!is_lesson && this.state.my_files_sort != '') {
                delimiter = firstParam ? '?' : '&';
                filesApiURL += delimiter + 'sort=' + this.state.my_files_sort;
            }
            api().get(filesApiURL)
                .then((response) => {
                    is_lesson
                        ? this.setState({student_files_meta: response.data.meta, filesLoading: false})
                        : this.setState({files_meta: response.data.meta, filesLoading: false});
                    is_lesson
                        ? this.setState({lessonFiles: response.data.data, filesLoading: false})
                        : this.setState({yourFiles: response.data.data, filesLoading: false});
                });
        });
    }

    handleCreateFileSubmit(event) {
        event.preventDefault();
        var data = new FormData();
        var error = false;
        if (this.state.file_input.size > 100000000) {
            error = true;
            this.setState({file_creation_error: 'File too large! Limit of 100MB.'})
        }
        if (!['image/jpeg', 'image/bmp', 'image/png', 'text/csv', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/xml', 'application/pdf',].includes(this.state.file_input.type)) {
            error = true;
            this.setState({file_creation_error: 'File not a supported filetype (' + this.state.file_input.type + ')'})
        }
        if (this.state.file_name == '') {
            error = true;
            this.setState({file_creation_error: 'File must have name'})
        }
        if (!error) {
            data.append("file", this.state.file_input);
            data.append("name", this.state.file_name);
            data.append("session_uuid", this.state.modal_open === "lesson_file" ? this.props.lesson_id : null);
            if (this.state.selectedFileStudents) {
                var $user_ids = [];
                this.state.selectedFileStudents.forEach(function (item) {
                    $user_ids.push(item.value);
                });
                if ($user_ids) {
                    data.append('extra_user_ids', $user_ids);
                }
            }
            api().post("files", data).then((response) => {
                if (this.state.modal_open === "lesson_file") {
                    this.pullFiles(true);
                    this.pullFiles();
                } else {
                    this.pullFiles();
                }
                document.querySelector(".file-input").value = "";
                this.setState({
                    file_creation_error: null, modal_open: null, file_name: '', file_input_val: null, file_input: null
                });


                toast.success('Success! File saved successfully!', {
                    position: "top-right", autoClose: 5000, hideProgressBar: true, closeOnClick: true,
                });
            });
        }
    }

    handleTimezoneSubmit(event) {
        event.preventDefault();
        api().put('user-timezone', {
            timezone: this.state.edit_timezone
        }).then(() => {
            this.setState({user_timezone: this.state.edit_timezone});
            toast.success('Success! Timezone updated successfully!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
            });
            this.setState({
                'timezone_modal_open': false
            });
            this.setOpenMenu(null);
            this.props.closeDeleteSessionModal();
        });
    }

    handleCreateSessionSubmit(event) {
        event.preventDefault();
        // Guard: a null/invalid datetime would throw on `.format()` below and
        // surface as a generic red modal error (the failure teachers hit on the
        // second lesson). Show a clear message and stop instead of crashing.
        if (!this.state.session_datetime || typeof this.state.session_datetime.format !== 'function') {
            this.setState({session_saving: false, session_creation_error: 'Please select a date and time for the lesson.'});
            return;
        }
        this.setState({session_saving: true, session_creation_error: null});
        try {
            this.setState({
                created_session_datetime: this.state.session_datetime,
                created_session_name: this.state.lesson_name,
                created_session_description: this.state.lesson_description,
                created_repeat: this.state.recurring_session_occurrences !== '' ? true : null,
                created_student_id: this.state.student_id
            });
            api().post('sessions', {
                student_id: this.state.student_id,
                student_ids: this.state.student_ids,
                scheduled_at: moment.tz(this.state.session_datetime.format(), this.state.user_timezone),
                recurring_session_type: this.state.recurring_session_occurrences !== '' ? this.state.recurring_session_type : 'repeat-weekly',
                repeat: this.state.recurring_session_occurrences !== '' ? true : null,
                recurring_session_occurrences: this.state.recurring_session_occurrences !== '' ? this.state.recurring_session_occurrences : '',
                email_invite: this.state.recurring_session_email_invite,
                name: this.state.lesson_name,
                description: this.state.lesson_description
            }).then((response) => {
                this.setState({
                    modal_open: null,
                    recurring_session_type: '',
                    repeat: null,
                    recurring_session_checkbox: false,
                    lesson_description: null,
                    lesson_name: null,
                    created_student_name: this.state.recurring_session_email_invite ? this.state.recurring_session_email_invite : (response.data.data ? response.data.data.participant_string : '')
                });
                this.props.closeSessionModal();
                this.props.fetchLessons();
            }).then(() => {
                console.log('then!');
                if (this.state.recurring_session_email_invite != '') {
                    toast.success('Success! Invite sent to student!', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
                this.setState({
                    modal_open: 'lesson-review',
                    // Match the initial state ('' not 0): a literal 0 was sent as
                    // sessions.student_id on the next create and broke the FK.
                    student_id: '',
                    student_ids: [],
                    session_datetime: null,
                    session_form_key: this.state.session_form_key + 1,
                    session_creation_error: null,
                    recurring_session_checkbox: false,
                    recurring_session_type: '',
                    recurring_session_occurrences: '',
                    recurring_session_email_invite: '',
                    session_saving: false,
                    lesson_description: null,
                    lesson_name: null,
                });
                jQuery('.modal-input').val(null);
                jQuery('.modal-description').val(null);
            }).catch((response) => {
                console.log('catch!');
                console.log(response);
                const errors = response?.response?.data?.errors;
                const message = errors ? Object.values(errors).flat().join(' ') : 'There was a problem creating the lesson. Please try again.';
                this.setState({session_saving: false, session_creation_error: message});
            });
        } catch (error) {
            this.setState({
                session_saving: false, session_creation_error: 'There is a problem with your input. Please try again.'
            });
        }
    }


    handleCreateNoteSubmit(event) {
        event.preventDefault();
        api().post('notes', {
            name: this.state.note_name,
            content: this.state.note_content_for_form,
            session_uuid: this.state.modal_open === "lesson_note" ? this.props.lesson_id : null,
            extra_user_ids: this.state.selectedNoteStudents
        }).then(() => {
            if (this.state.modal_open === "lesson_note") {
                this.pullNotes(true);
                this.pullNotes();
            } else {
                this.pullNotes();
            }
            localStorage.removeItem('muze_note_draft');
            this.setState({modal_open: null, note_content: RichTextEditor.createEmptyValue(), note_name: '', note_draft_available: false, note_minimized: false});
            toast.success('Success! Note created successfully!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        })
    }

    handleEditNoteSubmit(event) {
        event.preventDefault();
        api().put('notes/' + this.state.edit_note_id, {
            name: this.state.edit_note_name,
            content: this.state.edit_note_content_for_form,
            extra_user_ids: this.state.selectedEditNoteStudents
        }).then(() => {
            this.pullNotes(true);
            this.pullNotes();
            this.setState({
                modal_open: null, edit_note_content: RichTextEditor.createEmptyValue(), edit_note_name: null, edit_note_save_status: null, note_minimized: false
            });
            toast.success('Success! Note edited successfully!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        })
    }

    handleEditFileSubmit(event) {
        event.preventDefault();
        api().put('files/' + this.state.edit_file_id, {
            name: this.state.edit_file_name, extra_user_ids: this.state.selectedEditFileStudents
        }).then(() => {
            this.pullFiles(true);
            this.pullFiles();
            this.setState({
                modal_open: null, edit_file_name: null
            });
            toast.success('Success! File edited successfully!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        })
    }

    handleEditClipSubmit(event) {
        event.preventDefault();
        api().put('clips/' + this.state.edit_clip_id, {
            name: this.state.edit_clip_name, extra_user_ids: this.state.selectedEditClipStudents
        }).then(() => {
            this.pullClips(true);
            this.pullClips();
            this.setState({modal_open: null, edit_clip_name: null});
            toast.success('Success! Clip edited successfully!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        })
    }

    setTime() {
        if (!this.state.recording_paused) {
            this.setState({rec_seconds: ++this.state.rec_seconds});
            var seconds = this.pad(this.state.rec_seconds % 60);
            var minutes = this.pad(parseInt(this.state.rec_seconds / 60));
            this.setState({recording_time: minutes + ":" + seconds});
        }
    }

    cancelInvite(uuid) {
        if (!uuid) {
            console.error('cancelInvite: missing uuid');
            return;
        }
        if (!window.confirm('Cancel this invite?')) {
            return;
        }
        api().delete(`/student-invite/${uuid}`)
            .then(() => {
                this.pullStudents();
            })
            .catch((error) => {
                console.error('Error cancelling invite:', error);
            });
    }

    handleStudentInviteSubmit(event) {
        this.setState({student_invite_form_error: null, student_invite_form_success: null});
        event.preventDefault();

        api().post('invite-student', {
            'student_invite_email': this.state.student_invite_email
        }).then(response => {
            if (response.data.success) {
                this.setState({student_invite_form_success: 'Student invited successfully!', student_invite_email: ''});
                this.pullStudents();
            } else {
                this.setState({student_invite_form_error: 'Student not invited successfully!'});
            }
        }).catch((error) => {
            this.setState({student_invite_form_error: 'Failed to send invite. Please try again.'});
            console.error('Error sending invite:', error);
        });
    }

    handleChangePasswordSubmit(event) {
        this.setState({password_form_error: null, password_form_success: null});
        event.preventDefault();
        if (this.state.change_password === this.state.change_confirm_password) {
            api().post('change-password', {
                'password': this.state.change_password, 'confirm_password': this.state.change_confirm_password,
            }).then(response => {
                this.setState({password_form_success: 'Password changed successfully!'});
                this.setState({modal_open: null})
            });
        } else {
            this.setState({password_form_error: 'Entered passwords do not match!'});
        }
    }

    handleAccountFormSubmit(event) {
        this.setState({account_form_error: null, account_form_success: null});
        event.preventDefault();
        api().post('post-account-form', {
            name: this.state.edit_name,
            email: this.state.edit_email,
            student_name: this.state.edit_student_name,
            timezone: this.state.edit_timezone,
        }).then(response => {
            if (response.data.success) {
                this.setState({account_form_success: 'Account settings saved successfully!'});
            } else {
                this.setState({account_form_error: response.data.error_msg});
            }
            this.setState({modal_open: null})
        });
    }

    handleChangeNameSubmit(event) {
        event.preventDefault();
        api().post('change-name', {
            'name': this.state.edit_name,
        }).then(response => {
            toast.success('Success! Name changed successfully!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            this.setState({modal_open: null})
        });
    }

    handleChangeEmailSubmit(event) {
        event.preventDefault();
        api().post('/check-email', {
            email: this.state.edit_email
        }).then((response) => {
            if (!response.data.success) {
                api().post('change-email', {
                    'email': this.state.edit_email,
                }).then(response => {
                    toast.success('Success! Email changed successfully!', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.setState({modal_open: null, change_email_error: null})
                });
            } else {
                this.setState({change_email_error: 'This email address has already been taken'});
            }
        });

    }


    handleCreateClipSubmit(event) {
        api().get("session/" + this.props.lesson_id + "/startCountdown");
        event.preventDefault();
        this.setState({modal_open: null, recording_pre: true, rec_seconds: 0, recording_time: '00:00'});
        var component = this;
        setTimeout(function () {
            component.setState({
                recording_notice: "Recording Starting in 2...",
            });
            setTimeout(function () {
                component.setState({
                    recording_notice: "Recording Starting in 1...",
                });
                setTimeout(function () {

                    api().post('clips', {
                        name: component.state.clip_name,
                        session_uuid: component.props.lesson_id,
                        extra_user_ids: component.state.selectedClipStudents
                    }).then(response => {
                        component.setState({
                            recording_now: true,
                            show_recording_button: true,
                            recording_pre: false,
                            archive_id: response.data.data.archive_id,
                            clip_name: '',
                            rec_seconds: 0,
                            recording_time: '00:00'
                        });

                        // Guard against a duplicate interval: the recorder also receives its own
                        // StartCountdown echo, which starts a second interval -> counter ticks +2/sec.
                        if (component.state.clip_timeout) {
                            clearInterval(component.state.clip_timeout);
                        }
                        var clip_timeout = setInterval(function () {
                            component.setTime();
                        }, 1000);
                        component.setState({
                            clip_timeout: clip_timeout
                        });
                    })
                }, 1000);
            }, 1000);
        }, 1000);
    }

    checkClipSuccess() {
        if (this.state.archive_id) {
            api().get('/clips/archive_id/' + this.state.archive_id)
                .then((data) => {
                    if (data.data.data.status == 'uploaded') {
                        module = this;
                        setTimeout(function () {
                            toast.success('Success! Clip saved successfully!', {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            module.pullClips(true);
                            module.pullClips();
                        }, 15000);
                    } else {
                        setTimeout(this.checkClipSuccess.bind(this), 4000);
                    }
                });
        }
    }

    toggleRecording() {
        api().get("stopArchive/?archive_id=" + this.state.archive_id)
            .then((data) => {
                api().get("session/" + this.props.lesson_id + "/stopRecording");
                if (this.state.clip_timeout) {
                    clearInterval(this.state.clip_timeout);
                }
                this.setState({
                    recording_now: false,
                    rec_seconds: 0,
                    recording_time: '00:00',
                    recording_notice: "Recording Starting in 3..."
                });


                toast.success('Clip processing...', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });

                this.checkClipSuccess();


            });
    }

    pad(val) {
        var valString = val + "";
        if (valString.length < 2) {
            return "0" + valString;
        } else {
            return valString;
        }
    }

    handleRedirectHome() {
        if (this.props.in_lesson) {

            var r = confirm("Are you sure you want to end your session?");
            if (r == true) {
                window.location.href = '/?review_session_uuid=' + this.props.lesson_id;
            }
        } else {
            window.location.href = '/';
        }
    }

    findGetParameter(parameterName) {
        var result = null, tmp = [];
        location.search
            .substr(1)
            .split("&")
            .forEach(function (item) {
                tmp = item.split("=");
                if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            });
        return result;
    }

    render() {
        let note_modal_heading = "Create New Note";
        let file_modal_heading = "Add File";
        let clip_modal_heading = "Create New Clip";
        var yesterday = moment().subtract(1, 'day');
        var valid = function (current) {
            return current.isAfter(yesterday);
        };
        var add_text = this.props.isInstructor ? 'student' : 'instructor';

        const toolbarConfig = {
            display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'LINK_BUTTONS', 'HISTORY_BUTTONS'],
            INLINE_STYLE_BUTTONS: [
                {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
                {label: 'Italic', style: 'ITALIC'},
                {label: 'Underline', style: 'UNDERLINE'}
            ],
            BLOCK_TYPE_DROPDOWN: [
                {label: 'Normal', style: 'unstyled'},
                {label: 'Heading Large', style: 'header-one'},
                {label: 'Heading Medium', style: 'header-two'},
                {label: 'Heading Small', style: 'header-three'}
            ],
            BLOCK_TYPE_BUTTONS: [{label: 'UL', style: 'unordered-list-item'}, {label: 'OL', style: 'ordered-list-item'}]
        };
        var is_tablet = window.innerWidth < 1096;

        window.addEventListener('resize', function () {
            is_tablet = window.innerWidth < 1096;
        });

        const deletedSessionIsRepeat = this.props.deletedSession &&
            (this.props.deletedSession.repeat === '1');
        const deletedSessionIsParent = this.props.deletedSession &&
            (this.props.deletedSession.parent_id !== null);

        const deletedSessionIsRepeatOrChild = this.props.deletedSession &&
            (deletedSessionIsRepeat || deletedSessionIsParent);


        return (<>
            <SidebarWrapper>
                <SidebarLogo onClick={(e) => {
                    e.preventDefault();
                    this.handleRedirectHome();
                }} href="/">
                    <SidebarLogoImg src={SidebarLogoImgSrc}></SidebarLogoImg>
                </SidebarLogo>
                <IconGroupWrapper>
                    <IconGroup position="top">
                        <Icon
                            active={this.state.active_subscription}
                            onClick={() => {
                                if (this.state.active_subscription) {

                                    this.state.open_menu === 0 ? this.setOpenMenu(null) : this.setOpenMenu(0);
                                }
                            }}
                            open={this.state.open_menu === 0}>
                            <IconImage src={ClipsIcon}
                                       open={this.state.open_menu === 0}></IconImage>
                            <IconName open={this.state.open_menu === 0}>Clips</IconName>
                        </Icon>
                        <Icon
                            active={this.state.active_subscription}
                            onClick={() => {
                                if (this.state.active_subscription) {
                                    this.state.open_menu === 1 ? this.setOpenMenu(null) : this.setOpenMenu(1);
                                }
                            }}
                            open={this.state.open_menu === 1}
                        >
                            <IconImage src={NotesIcon}
                                       open={this.state.open_menu === 1}></IconImage>
                            <IconName open={this.state.open_menu === 1}>Notes</IconName>
                        </Icon>
                        <Icon
                            active={this.state.active_subscription}
                            onClick={() => {

                                if (this.state.active_subscription) {
                                        this.state.open_menu === 2
                                            ? this.setOpenMenu(null)
                                            : this.setOpenMenu(2);
                                    }
                                }
                                }
                                open={this.state.open_menu === 2}
                            >
                                <IconImage src={FilesIcon}
                                           open={this.state.open_menu === 2}></IconImage>
                                <IconName open={this.state.open_menu === 2}>Files</IconName>
                            </Icon>
                        </IconGroup>
                        <IconGroup position="middle">
                            <Icon
                                active={this.state.active_subscription}
                                className="tuner-button"
                                onClick={() => {

                                if (this.state.active_subscription) {
                                        this.state.open_menu === 3
                                            ? this.setOpenMenu(null)
                                            : this.setOpenMenu(3);
                                    }
                                }
                                }
                                open={this.state.open_menu === 3}
                            >
                                <IconImage className="tuner-button-image" src={TunerIcon}
                                           open={this.state.open_menu === 3}></IconImage>
                            <IconName className="tuner-button-text"
                                      open={this.state.open_menu === 3}>Tuner</IconName>
                        </Icon>
                        <Icon
                            active={this.state.active_subscription}
                            className="metronome-button"
                            hidden={false}
                            onClick={() => {
                                if (this.state.active_subscription) {
                                    this.state.open_menu === 4 ? this.setOpenMenu(null) : this.setOpenMenu(4);
                                }
                            }}
                            open={this.state.open_menu === 4}
                        >
                            <IconImage className="metronome-button-image" src={MetronomeIcon}
                                       open={this.state.open_menu === 4}></IconImage>
                            <IconName className="metronome-button-text"
                                      open={this.state.open_menu === 4}>Metronome</IconName>
                        </Icon>
                        <Icon
                            active={this.state.active_subscription}
                            hidden={!this.props.in_lesson || !this.props.isInstructor}
                            onClick={() => {

                                if (this.state.active_subscription) {
                                        this.state.open_menu === 5
                                            ? this.setOpenMenu(null)
                                            : this.setOpenMenu(5);
                                    }
                                }
                                }
                                open={this.state.open_menu === 5}
                            >
                                <IconImage src={VisualCuesIcon}
                                           open={this.state.open_menu === 5}></IconImage>
                                <IconName open={this.state.open_menu === 5}>Visual Cues</IconName>
                            </Icon>
                        </IconGroup>
                        <IconGroup position="bottom">
                            <Icon
                                hidden={true}
                                onClick={() => {
                                this.state.open_menu === 6 ? this.setOpenMenu(null) : this.setOpenMenu(6);
                                }}
                                open={this.state.open_menu === 6}
                            >
                                <IconImage src={AccountIcon}
                                           open={this.state.open_menu === 6}></IconImage>
                                <IconName open={this.state.open_menu === 6}>Account</IconName>
                            </Icon>
                            <Icon
                                hidden={true}
                                onClick={() => {
                                this.state.open_menu === 7 ? this.setOpenMenu(null) : this.setOpenMenu(7);
                            }}
                            open={this.state.open_menu === 7}
                        >
                            <IconImage src={MuteIcon}
                                       open={this.state.open_menu === 7}></IconImage>
                            <IconName open={this.state.open_menu === 7}>Mute</IconName>
                        </Icon>
                        <Icon
                            hidden={true}
                            layout={true}
                            onClick={() => {
                                this.props.togglePictureInPicture()
                            }}
                        >
                            <IconName layout={true}>Toggle <br/>Layout</IconName>
                        </Icon>

                            <Icon
                                onClick={() => {
                                this.state.open_menu === 8 ? this.setOpenMenu(null) : this.setOpenMenu(8);
                            }}
                            open={this.state.open_menu === 8}
                            active={true}
                        >
                            <IconImage src={MoreIcon}
                                       open={this.state.open_menu === 8}></IconImage>
                            <IconName open={this.state.open_menu === 8}>More</IconName>
                        </Icon>
                        <br/>
                        <Icon className="end-lesson-icon" hidden={!this.props.in_lesson}
                              button={true}
                              onClick={(e) => {
                                  e.preventDefault();
                                  this.handleRedirectHome();
                              }}
                        >
                            {this.findGetParameter('full') ? 'Go Back' : 'End Lesson'}
                        </Icon>

                        </IconGroup>
                    </IconGroupWrapper>
                </SidebarWrapper>
                <SidebarMenu
                open={this.state.open_menu !== null && (this.state.open_menu < 3)}
            >
                <ClipMenu
                    recordAllSessions={this.props.recordAllSessions}
                    lesson_id={this.props.lesson_id}
                    inLesson={this.props.in_lesson}
                    lessonClips={this.state.lessonClips}
                    yourClips={this.state.yourClips}
                    open={this.state.open_menu === 0}
                    newClipAction={this.openCreateNewClip}
                    newLessonClipAction={this.openCreateNewLessonClip}
                    openClipAction={this.openClipAction}
                    searchMyClips={this.searchMyClips}
                    selectStudent={this.selectStudent}
                    selectSort={this.selectSort}
                    searchLessonClips={this.searchLessonClips}
                    editClipAction={this.openEditClip}
                    isInstructor={this.props.isInstructor}
                    paginationMeta={this.state.clips_meta}
                    studentPaginationMeta={this.state.student_clips_meta}
                    clipsLoading={this.state.clipsLoading}
                    pullClips={(in_lesson, page) => {
                        this.pullClips(in_lesson, page);
                    }}
                    students={this.state.students}
                ></ClipMenu>
                <NotesMenu
                    notesLoading={this.state.notesLoading}
                    lesson_id={this.props.lesson_id}
                    inLesson={this.props.in_lesson}
                    lessonNotes={this.state.lessonNotes}
                    yourNotes={this.state.yourNotes}
                    open={this.state.open_menu === 1}
                    newNoteAction={this.openCreateNewNote}
                    editNoteAction={this.openEditNote}
                    viewNoteAction={this.openViewNote}
                    togglePinAction={this.toggleNotePin}
                    newLessonNoteAction={this.openCreateNewLessonNote}
                    searchMyNotes={this.searchMyNotes}
                    selectStudent={this.selectStudent}
                    selectSort={this.selectSort}
                    searchLessonNotes={this.searchLessonNotes}
                    isInstructor={this.props.isInstructor}
                    paginationMeta={this.state.notes_meta}
                    studentPaginationMeta={this.state.student_notes_meta}
                    pullNotes={(in_lesson, page) => {
                        this.pullNotes(in_lesson, page);
                    }}
                    students={this.state.students}
                ></NotesMenu>
                {this.props.isInstructor && (
                <FilesMenu
                    filesLoading={this.state.filesLoading}
                    lesson_id={this.props.lesson_id}
                    inLesson={this.props.in_lesson}
                    lessonFiles={this.state.lessonFiles}
                    yourFiles={this.state.yourFiles}
                    open={this.state.open_menu === 2}
                    newFileAction={this.openCreateNewFile}
                    newLessonFileAction={this.openCreateNewLessonFile}
                    searchMyFiles={this.searchMyFiles}
                    selectStudent={this.selectStudent}
                    selectSort={this.selectSort}
                    searchLessonFiles={this.searchLessonFiles}
                    editFileAction={this.openEditFile}
                    isInstructor={this.props.isInstructor}
                    paginationMeta={this.state.files_meta}
                    studentPaginationMeta={this.state.student_files_meta}
                    pullFiles={(in_lesson, page) => {
                        this.pullFiles(in_lesson, page);
                    }}
                    students={this.state.students}
                ></FilesMenu>
                )}
                {!this.props.isInstructor && (
                    <StudentFilesMenu
                        open={this.state.open_menu === 2}
                        filesLoading={this.state.filesLoading}
                        yourFiles={this.state.yourFiles}
                        paginationMeta={this.state.files_meta}
                        pullFiles={(in_lesson, page) => { this.pullFiles(in_lesson, page); }}
                        searchMyFiles={this.searchMyFiles}
                        selectSort={this.selectSort}
                        newFileAction={() => this.setState({ studentUploadOpen: true, open_menu: null })}
                        shareFileAction={(fileId) => this.setState({ studentShareOpen: true, studentShareFileId: fileId })}
                    />
                )}
            </SidebarMenu>
                <MoreMenu open={
                    this.state.open_menu === 8 ||
                    (this.state.open_menu === 9 && !is_tablet) ||
                    (this.state.open_menu === 10 && !is_tablet) ||
                    (this.state.open_menu === 11 && !is_tablet) ||
                    (this.state.open_menu === 12 && !is_tablet) ||
                    (this.state.open_menu === 13 && !is_tablet) ||
                    (this.state.modal_open === 'password' && !is_tablet) ||
                    (this.state.modal_open === 'account' && !is_tablet)
                }>

                <Tabs>
                    <Tab fullwidth={true}
                         open={true}>{"Settings"}</Tab>
                </Tabs>
                <MenuClose
                    onClick={() => {
                        this.setOpenMenu(null);
                    }}
                >
                    <img src={OnboardingCloseIcon} alt=""/>
                </MenuClose>

                <MoreMenuItem hidden={true || !this.props.isInstructor} onClick={() => {
                    window.location.href = '/billing-portal'
                }}>
                    {"Billing Portal"}
                </MoreMenuItem>

                <MoreMenuItem onClick={(e) => {
                    e.preventDefault();
                    this.setState({open_menu: null, modal_open: 'account'});
                }}>
                    {"Account"}
                </MoreMenuItem>

                <MoreMenuItem hidden={!this.state.show_subscription}
                              onClick={() => this.state.open_menu === 10 ? this.setOpenMenu(null) : this.setOpenMenu(10)}>
                        {"Subscription + Payment"}
                    </MoreMenuItem>


                <MoreMenuItem hidden={!this.props.isInstructor}
                              onClick={() => { this.state.open_menu === 11 ? this.setOpenMenu(null) : this.setOpenMenu(11); this.pullStudents(); }}>
                        {"Manage Students"}
                    </MoreMenuItem>


                <MoreMenuItem onClick={() => this.state.open_menu === 10 ? this.setOpenMenu(null) : this.setState({
                    open_menu: null,
                    modal_open: 'password'
                })}>
                        {"Password + Security"}
                    </MoreMenuItem>


                <MoreMenuItem hidden={true}
                              onClick={() => this.state.open_menu === 10 ? this.setOpenMenu(null) : this.setOpenMenu(13)}>
                        {"Referrals"}
                    </MoreMenuItem>

                <MoreMenuItem onClick={(e) => {
                    e.preventDefault();
                    this.setState({open_menu: null, modal_open: null, onboarding_step: 20});
                }}>
                    {"Contact Us"}
                </MoreMenuItem>

                    <MoreMenuItem
                        hidden={true}>
                        {"Settings"}
                    </MoreMenuItem>
                    <MoreMenuItem
                        hidden={true}>
                        {"Report a Problem"}
                    </MoreMenuItem>
                <MoreMenuItem onClick={() => {
                    this.setOpenMenu(null);
                    this.setState({onboarding_step: 19});
                }}>
                    {"Help"}
                </MoreMenuItem>
                <MoreMenuItem onClick={() => {
                    api(true).post('/fortify/logout')
                        .then(() => {
                            log_out();
                        });
                }}>
                    {"Logout"}
                </MoreMenuItem>
            </MoreMenu>
            <TunerPopup open={this.state.open_menu === 3}>
                <MenuClose
                    onClick={() => {
                        this.setOpenMenu(null);
                    }}
                >
                    <img src={OnboardingCloseIcon} alt=""/>
                </MenuClose>
                {this.state.open_menu === 3 && (<Tuner/>)}
            </TunerPopup>
            <MetronomePopup open={this.state.open_menu === 4}>
                <MenuClose
                    onClick={() => {
                        this.setOpenMenu(null);
                    }}
                >
                    <img src={OnboardingCloseIcon} alt=""/>
                </MenuClose>
                <Metronome active={this.state.open_menu === 4}/>
            </MetronomePopup>
            <VisualCuesPopup open={this.state.open_menu === 5}>
                <MenuClose
                    onClick={() => {
                        this.setOpenMenu(null);
                    }}
                >
                    <img src={OnboardingCloseIcon} alt=""/>
                </MenuClose>
                <PopupHeading>{"Visual Cues"}</PopupHeading>
                <VisualCues>
                    <VisualCue onClick={() => {
                        api().post(`session/${this.props.lesson_id}/visual_cues`, {
                            cue: StopIcon, cue_text: 'Stop'
                        })
                    }}>
                        <VisualCueIcon src={StopIcon}/>
                        <VisualCueHeading>{"Stop"}</VisualCueHeading>
                    </VisualCue>
                    <VisualCue onClick={() => {
                        api().post(`session/${this.props.lesson_id}/visual_cues`, {
                            cue: GoIcon, cue_text: 'Go'
                        })
                    }}>
                        <VisualCueIcon src={GoIcon}/>
                        <VisualCueHeading>{"Go"}</VisualCueHeading>
                    </VisualCue>
                    <VisualCue onClick={() => {
                        api().post(`session/${this.props.lesson_id}/visual_cues`, {
                            cue: RushingIcon, cue_text: 'Rushing'
                        })
                    }}>
                        <VisualCueIcon src={RushingIcon}/>
                        <VisualCueHeading>{"Rushing"}</VisualCueHeading>
                    </VisualCue>
                    <VisualCue onClick={() => {
                        api().post(`session/${this.props.lesson_id}/visual_cues`, {
                            cue: DraggingIcon, cue_text: 'Dragging'
                        })
                    }}>
                        <VisualCueIcon src={DraggingIcon}/>
                        <VisualCueHeading>{"Dragging"}</VisualCueHeading>
                    </VisualCue>
                    <VisualCue onClick={() => {
                        api().post(`session/${this.props.lesson_id}/visual_cues`, {
                            cue: ApplauseIcon, cue_text: 'Applause'
                        })
                    }}>
                        <VisualCueIcon src={ApplauseIcon}/>
                        <VisualCueHeading>{"Applause"}</VisualCueHeading>
                    </VisualCue>
                    <VisualCue onClick={() => {
                        api().post(`session/${this.props.lesson_id}/visual_cues`, {
                            cue: PianissimoIcon, cue_text: 'Pianissimo'
                        })
                    }}>
                        <VisualCueIcon src={PianissimoIcon}/>
                        <VisualCueHeading>{"Pianissimo"}</VisualCueHeading>
                    </VisualCue>
                    <VisualCue onClick={() => {
                        api().post(`session/${this.props.lesson_id}/visual_cues`, {
                            cue: PianoIcon, cue_text: 'Piano'
                        })
                    }}>
                        <VisualCueIcon src={PianoIcon}/>
                        <VisualCueHeading>{"Piano"}</VisualCueHeading>
                    </VisualCue>
                    <VisualCue onClick={() => {
                        api().post(`session/${this.props.lesson_id}/visual_cues`, {
                            cue: MezzopianoIcon, cue_text: 'Mezzo Piano'
                        })
                    }}>
                        <VisualCueIcon src={MezzopianoIcon}/>
                        <VisualCueHeading>{"Mezzo Piano"}</VisualCueHeading>
                    </VisualCue>
                    <VisualCue onClick={() => {
                        api().post(`session/${this.props.lesson_id}/visual_cues`, {
                            cue: MezzoforteIcon, cue_text: 'Mezzo Forte'
                        })
                    }}>
                        <VisualCueIcon src={MezzoforteIcon}/>
                        <VisualCueHeading>{"Mezzo Forte"}</VisualCueHeading>
                    </VisualCue>
                    <VisualCue onClick={() => {
                        api().post(`session/${this.props.lesson_id}/visual_cues`, {
                            cue: ForteIcon, cue_text: 'Forte'
                        })
                    }}>
                        <VisualCueIcon src={ForteIcon}/>
                        <VisualCueHeading>{"Forte"}</VisualCueHeading>
                    </VisualCue>
                    <VisualCue onClick={() => {
                        api().post(`session/${this.props.lesson_id}/visual_cues`, {
                            cue: FortisimoIcon, cue_text: 'Fortissimo'
                        })
                    }}>
                        <VisualCueIcon src={FortisimoIcon}/>
                        <VisualCueHeading>{"Fortissimo"}</VisualCueHeading>
                    </VisualCue>
                </VisualCues>
            </VisualCuesPopup>

                <Modal id="clip-modal"
                   open={this.state.modal_open === "clip" || this.state.modal_open === "lesson_clip"}
            >
                <DraggableHeader id="clip-modal-header"></DraggableHeader>
                <ModalClose onClick={() => {
                    this.setState({modal_open: null})
                }}>X</ModalClose>

                    <form onSubmit={this.handleCreateClipSubmit}>
                        <ModalHeading>{clip_modal_heading}</ModalHeading>

                    <MultiSelectWrapper>
                        <ModalSubheading>Want to assign to a {add_text} or {add_text}s?</ModalSubheading>
                        <MultiSelect
                            required
                            options={this.state.student_options}
                            onChange={(e) => {
                                this.setState({selectedClipStudents: e})
                            }}
                            value={this.state.selectedClipStudents}
                            labelledBy={"Select"}
                        />
                    </MultiSelectWrapper>

                        <ModalInput
                            value={this.state.clip_name}
                            onChange={this.handleCreateClipNameInputChange}
                            placeholder="Enter Clip Name"
                        ></ModalInput>
                        <ModalButton>{"Begin Recording"}</ModalButton>
                        <ModalNote>
                        </ModalNote>
                    </form>
                </Modal>


                <AccountModal
                    is_tablet={is_tablet}
                open={this.state.modal_open === "account"}
            >
                <ModalClose onClick={() => {
                    this.setState({modal_open: null})
                }}>X</ModalClose>

                    <form onSubmit={this.handleAccountFormSubmit}>
                        <AccountModalHeading>Account</AccountModalHeading>
                        {this.state.account_form_error ? (
                            <OrangeError><i className="fas fa-exclamation-triangle"></i>{this.state.account_form_error}
                        </OrangeError>) : (<></>)}
                        {this.state.account_form_success ? (
                            <Success><i className="fas fa-check"></i>{this.state.account_form_success}</Success>
                        ) : (<></>)}

                        <Hidden><AccountModalSubHeading>Avatar</AccountModalSubHeading>
                            <AvatarImage></AvatarImage>
                            <AvatarButton purple={true}>Upload New</AvatarButton>
                            <AvatarButton>Remove</AvatarButton>
                            <hr/>
                        </Hidden>
                        <AccountModalSubHeading>Name</AccountModalSubHeading>
                        <AccountModalInput
                            type="text"
                            value={this.state.edit_name}
                        onChange={(event) => {
                            this.setState({edit_name: event.target.value})
                        }}
                            placeholder="Full Name"
                        ></AccountModalInput>
                        <br/>
                    {this.props.isInstructor ? (<></>) : (<>
                                <AccountModalSubHeading>Student Name</AccountModalSubHeading>
                                <AccountModalInput
                                    type="text"
                                    value={this.state.edit_student_name}
                            onChange={(event) => {
                                this.setState({edit_student_name: event.target.value})
                            }}
                                    placeholder="Student Name"
                                ></AccountModalInput>
                                <br/>
                    </>)}

                        <AccountModalSubHeading>Email</AccountModalSubHeading>
                        <AccountModalInput
                            type="text"
                            value={this.state.edit_email}
                        onChange={(event) => {
                            this.setState({edit_email: event.target.value})
                        }}
                            placeholder="Email Address"
                        ></AccountModalInput>

                        <hr/>
                        <AccountModalSubHeading>Timezone</AccountModalSubHeading>
                        <AccountModalSelect
                            id="timezone"
                            name="timezone"
                            value={this.state.edit_timezone || ''}
                            onChange={(event) => {
                                this.setState({edit_timezone: event.target.value})
                            }}>
                            {timezones.map(timezone => (
                                <option key={timezone} value={timezone}>{timezone}</option>
                            ))}
                        </AccountModalSelect>
                        <br/>
                        <ModalButton className="modal-button">{"Apply Changes"}<i
                            className="fas fa-chevron-right"></i></ModalButton>
                    <CancelButton onClick={() => {
                        this.setState({modal_open: null})
                    }}>Cancel</CancelButton>
                    </form>
                </AccountModal>

                <AccountModal
                    is_tablet={is_tablet}
                open={this.state.open_menu === 11}>
                <ModalClose onClick={() => {
                    this.setState({open_menu: null})
                }}>X</ModalClose>

                    <AccountModalHeading>Manage Students</AccountModalHeading>
                <p className="heading-note">
                    {this.state.students ? this.state.students.length : 0} registered student{this.state.students && this.state.students.length !== 1 ? 's' : ''}
                    {this.state.pending_invites && this.state.pending_invites.length > 0 ? `, ${this.state.pending_invites.length} pending` : ''}
                </p>

                <a className="refresh-button" onClick={() => {
                    this.pullStudents();
                }}>Refresh</a>

                    <TableWrapper>

                        <table>
                            <tbody>

                            <tr>
                                <th>NAME</th>
                                <th>EMAIL</th>
                                <th>STATUS</th>
                                <th>REMOVE</th>
                            </tr>
                        {this.state.students ? Object.keys(this.state.students).map((item, index) => (<>
                            <tr key={index}>
                                <td>{this.state.students[item].name}</td>
                                <td><a
                                    href={'mailto:' + this.state.students[item].email}>{this.state.students[item].email}</a>
                                </td>
                                <td><span className="status-accepted">ACCEPTED</span></td>
                                <td><a href="#" onClick={(e) => {
                                    e.preventDefault();
                                    this.removeStudent(this.state.students[item].student.id);
                                }}><i className="fas fa-times"></i></a></td>
                            </tr>
                        </>)) : ''}
                        {this.state.pending_invites ? this.state.pending_invites.map((invite, index) => (
                            <tr key={'pending-' + index}>
                                <td style={{color: '#999', fontStyle: 'italic'}}>Invited Student</td>
                                <td><a href={'mailto:' + invite.email}>{invite.email}</a></td>
                                <td><span style={{color: '#e67e22', fontWeight: 'bold'}}>REGISTRATION PENDING</span></td>
                                <td><a href="#" onClick={(e) => { e.preventDefault(); this.cancelInvite(invite.uuid); }}><i className="fas fa-times"></i></a></td>
                            </tr>
                        )) : ''}
                            </tbody>
                        </table>

                    </TableWrapper>
                    <div>
                        <AccountModalSubHeading>INVITE NEW STUDENT OR STUDENTS</AccountModalSubHeading>

                    {this.state.student_invite_form_error ? (<OrangeError><i
                        className="fas fa-exclamation-triangle"></i>{this.state.student_invite_form_error}
                    </OrangeError>) : (<></>)}
                        {this.state.student_invite_form_success ? (
                            <Success><i className="fas fa-check"></i>{this.state.student_invite_form_success}</Success>
                        ) : (<></>)}
                        <p>To send multiple email invitations separate each email with a comma (,) or space</p>
                        <h3>Student Email</h3>
                        <form onSubmit={this.handleStudentInviteSubmit}>
                            <StudentInviteInput value={this.state.student_invite_email}
                                                onChange={this.handleStudentInviteInputChange} type="text"
                                                placeholder="Type Email Here"/>
                            <StudentInviteButton>Send Invite</StudentInviteButton>
                        </form>
                    </div>

                </AccountModal>
                <AccountModal
                    is_tablet={is_tablet}
                open={this.state.open_menu === 10}>
                <ModalClose onClick={() => {
                    this.setState({open_menu: null})
                }}>X</ModalClose>

                <AccountModalHeading>Subscription + Payment</AccountModalHeading>
                <p>Need help? <a href="mailto:contact@learnwithmuze.com">Contact Us</a></p>
                <br/>
                    {this.state.subscription_info && (this.state.subscription_info.status == 'active' || this.state.subscription_info.status == 'trialing' || this.state.subscription_info.status == 'past_due') ? (<>
                    <AccountModalSubHeading>CURRENT SUBSCRIPTION</AccountModalSubHeading>
                    <p>Subscription Type:
                        <strong>{this.state.subscription_info ? this.state.subscription_info.plan_type : ''}</strong>
                    </p>
                    <p>Cost:
                        <strong>{this.state.subscription_info ? this.state.subscription_info.current_cost : ''}</strong>
                    </p>
                    <hr/>
                    <AccountModalSubHeading>PLAN DETAILS</AccountModalSubHeading>
                    {this.state.subscription_info.ends_at ? (<>
                        <p>Subscription ends on: <strong>{this.state.subscription_info.ends_at}</strong></p>
                    </>) : (<>
                        <p>Next Payment Due:
                            <strong>{this.state.subscription_info ? this.state.subscription_info.next_payment_due : ''}</strong>
                        </p>
                        <p>{this.state.subscription_info.has_payment_method ? 'Renewal' : 'End'} Date:
                            <strong>{this.state.subscription_info ? this.state.subscription_info.renewal_date : ''}</strong>
                        </p>
                        <p>Payment Method: <strong>{this.state.subscription_info.has_payment_method ? 'Credit Card on File' : 'N/A'}</strong>
                            </p>
                    </>)}
                    <hr/>
                    <AccountModalSubHeading>EDIT SUBSCRIPTION + PAYMENT</AccountModalSubHeading>
                    <p>All payment and subscription information is handled on <a href="/billing-portal">Stripe</a>
                    </p>
                    <ModalButton onClick={() => {
                        window.location.href = '/billing-portal'
                    }} className="modal-button">{"Edit Payment Info"}<i
                        className="fas fa-chevron-right"></i></ModalButton>&nbsp;&nbsp;
                    {this.state.subscription_info.ends_at ? (<>

                        <ModalButtonLink onClick={(e) => {
                            e.preventDefault();
                            if (confirm('Are you sure you want to renew your subscription?')) {

                                window.location.href = '/resume-subscription'
                            }
                        }} className="modal-button">Renew
                            Subscription</ModalButtonLink>
                    </>) : (<>

                        <ModalButtonLink onClick={(e) => {
                            e.preventDefault();
                            if (confirm('Are you sure you want to cancel your subscription?')) {

                                window.location.href = '/cancel-subscription'
                            }
                        }} className="modal-button">Cancel
                            Subscription</ModalButtonLink>
                    </>)}
                    <hr/>
                    <AccountModalSubHeading>BILLING HISTORY</AccountModalSubHeading>
                    <BillingHistoryTableWrapper>

                        <table>
                            {this.state.subscription_info && this.state.subscription_info.invoice_data ? (<>
                                {this.state.subscription_info.invoice_data.map((item, index) => (<tr>
                                                <td>{item.date}</td>
                                                <td>{item.price}</td>
                                                <td>{item.plan_name}</td>
                                </tr>))}
                            </>) : (<></>)}
                        </table>
                    </BillingHistoryTableWrapper>
                    <br/>
                    <a href="/billing-portal">View All Billing History</a>
                </>) : (<></>)}

                {this.state.subscription_info && this.state.subscription_info.status == 'canceled' ? (<>
                    <AccountModalSubHeading>CURRENT SUBSCRIPTION</AccountModalSubHeading>
                    <p>Subscription Type: <strong>Canceled</strong></p>
                    <AccountModalSubHeading>EDIT SUBSCRIPTION + PAYMENT</AccountModalSubHeading>
                    <p>All payment and subscription information is handled on <a href="/billing-portal">Stripe</a>
                    </p>
                    <ModalButtonLink target="_blank" href="/billing-portal"
                                     className="modal-button">{"View Stripe Info"}<i
                        className="fas fa-chevron-right"></i></ModalButtonLink>
                    <hr/>
                    <AccountModalSubHeading>Select Your Plan</AccountModalSubHeading>

                    <BillingForm className="plans">
                        <Plan hidden={false} htmlFor="yearly">
                            <PlanCheckbox name="plan_type" id="yearly" type="radio"
                                          checked={this.state.selectedPlan == 'yearly'} onChange={() => {
                                this.setState({selectedPlan: 'yearly'});
                            }}/>
                            <PlanHeader>Yearly</PlanHeader>
                            <PlanPrice><PlanPriceSuperscript>$</PlanPriceSuperscript>120<PlanPriceMonth>/yr</PlanPriceMonth></PlanPrice>
                        </Plan>
                        <Plan hidden={false} htmlFor="monthly">
                            <PlanCheckbox name="plan_type" id="monthly" type="radio"
                                          checked={this.state.selectedPlan == 'monthly'} onChange={() => {
                                this.setState({selectedPlan: 'monthly'});
                            }}/>
                            <PlanHeader>Monthly</PlanHeader>
                            <PlanPrice><PlanPriceSuperscript>$</PlanPriceSuperscript>12<PlanPriceMonth>/mo</PlanPriceMonth></PlanPrice>
                        </Plan>
                    </BillingForm>
                    <BillingForm>
                        <AccountModalSubHeading>Enter Your Credit Card Information</AccountModalSubHeading>
                        {this.state.billingFormError ? (<>
                            <OrangeError><i
                                className="fas fa-exclamation-triangle"></i>{this.state.billingFormError}
                            </OrangeError>
                            <br/>
                        </>) : (<></>)}
                        <BillingInput required onChange={(e) => {
                            this.setState({billingName: e.target.value});
                        }} type="text" placeholder="Name on Card"/>

                        <StripeInputWrapper>
                            <CardElement
                                options={{
                                    style: {
                                        base: {
                                            fontSize: '16px',
                                            border: '1px solid black',
                                            color: '#424770',
                                            '::placeholder': {
                                                color: '#aab7c4',
                                            },
                                        }, invalid: {
                                            color: '#9e2146',
                                        },
                                    },
                                }}
                            />
                        </StripeInputWrapper>

                        <BillingInput required onChange={(e) => {
                            this.setState({billingAddress: e.target.value});
                        }} type="text" placeholder="Enter Street Address"/>
                        <BillingInputSmall required onChange={(e) => {
                            this.setState({billingCity: e.target.value});
                        }} type="text" placeholder="City"/>
                        <BillingSelect required onChange={(e) => {
                            this.setState({billingState: e.target.value});
                        }}>
                            <option>State</option>
                            <option value="AL">Alabama</option>
                            <option value="AK">Alaska</option>
                            <option value="AZ">Arizona</option>
                            <option value="AR">Arkansas</option>
                            <option value="CA">California</option>
                            <option value="CO">Colorado</option>
                            <option value="CT">Connecticut</option>
                            <option value="DE">Delaware</option>
                            <option value="DC">District Of Columbia</option>
                            <option value="FL">Florida</option>
                            <option value="GA">Georgia</option>
                            <option value="HI">Hawaii</option>
                            <option value="ID">Idaho</option>
                            <option value="IL">Illinois</option>
                            <option value="IN">Indiana</option>
                            <option value="IA">Iowa</option>
                            <option value="KS">Kansas</option>
                            <option value="KY">Kentucky</option>
                            <option value="LA">Louisiana</option>
                            <option value="ME">Maine</option>
                            <option value="MD">Maryland</option>
                            <option value="MA">Massachusetts</option>
                            <option value="MI">Michigan</option>
                            <option value="MN">Minnesota</option>
                            <option value="MS">Mississippi</option>
                            <option value="MO">Missouri</option>
                            <option value="MT">Montana</option>
                            <option value="NE">Nebraska</option>
                            <option value="NV">Nevada</option>
                            <option value="NH">New Hampshire</option>
                            <option value="NJ">New Jersey</option>
                            <option value="NM">New Mexico</option>
                            <option value="NY">New York</option>
                            <option value="NC">North Carolina</option>
                            <option value="ND">North Dakota</option>
                            <option value="OH">Ohio</option>
                            <option value="OK">Oklahoma</option>
                            <option value="OR">Oregon</option>
                            <option value="PA">Pennsylvania</option>
                            <option value="RI">Rhode Island</option>
                            <option value="SC">South Carolina</option>
                            <option value="SD">South Dakota</option>
                            <option value="TN">Tennessee</option>
                            <option value="TX">Texas</option>
                            <option value="UT">Utah</option>
                            <option value="VT">Vermont</option>
                            <option value="VA">Virginia</option>
                            <option value="WA">Washington</option>
                            <option value="WV">West Virginia</option>
                            <option value="WI">Wisconsin</option>
                            <option value="WY">Wyoming</option>
                        </BillingSelect>
                        <ModalButton onClick={async (event) => {
                            event.preventDefault();

                            const {stripe, elements} = this.props;

                            if (!stripe || !elements) {
                                return;
                            }

                            const cardElement = elements.getElement(CardElement);

                            const {error, paymentMethod} = await stripe.createPaymentMethod({
                                type: 'card', card: cardElement, billing_details: {
                                    address: {
                                        city: this.state.billingCity,
                                        line1: this.state.billingAddress,
                                        state: this.state.billingState
                                    }, name: this.state.billingName
                                }
                            });

                            if (error) {
                                this.setState({billingFormError: error.message});
                            } else {
                                this.setState({billingFormError: ''});
                                axios.post('/resubscribe-instructor', {
                                    paymentMethodId: paymentMethod.id, selectedPlan: this.state.selectedPlan
                                }).then((response) => {
                                    if (response.data.success) {
                                        location.reload();
                                    }
                                });
                            }

                        }}>Resubscribe</ModalButton>
                    </BillingForm>
                    <hr/>
                    <AccountModalSubHeading>BILLING HISTORY</AccountModalSubHeading>
                    <BillingHistoryTableWrapper>

                        <table>
                            {this.state.subscription_info && this.state.subscription_info.invoice_data ? (<>
                                {this.state.subscription_info.invoice_data.map((item, index) => (<tr>
                                                <td>{item.date}</td>
                                                <td>{item.price}</td>
                                                <td>{item.plan_name}</td>
                                </tr>))}
                            </>) : (<></>)}
                        </table>
                    </BillingHistoryTableWrapper>
                    <br/>
                    <a href="/billing-portal">View All Billing History</a>
                </>) : (<></>)}


                </AccountModal>


                <AccountModal
                    is_tablet={is_tablet}
                open={this.state.modal_open === "password"}>


                    <form onSubmit={this.handleChangePasswordSubmit}>
                        <AccountModalHeading>Password + Security</AccountModalHeading>
                        {this.state.password_form_error ? (
                            <OrangeError><i className="fas fa-exclamation-triangle"></i>{this.state.password_form_error}
                        </OrangeError>) : (<></>)}
                        {this.state.password_form_success ? (
                            <Success><i className="fas fa-check"></i>{this.state.password_form_success}</Success>
                        ) : (<></>)}
                        <AccountModalSubHeading>NEW PASSWORD</AccountModalSubHeading>
                        <PasswordInput
                            type="password"
                            value={this.state.change_password}
                            onChange={this.handleChangePasswordInputChange}
                        ></PasswordInput>
                        <AccountModalSubHeading>CONFIRM NEW PASSWORD</AccountModalSubHeading>
                        <PasswordInput
                            type="password"
                            value={this.state.change_confirm_password}
                            onChange={this.handleChangeConfirmPasswordInputChange}
                        ></PasswordInput>
                        <br/>
                        <Hidden>
                        <AccountModalNote>Password must contain numbers, uppercase letters, at least one symbol, and
                            be
                                greater than 8 characters.</AccountModalNote>
                            <br/>
                        </Hidden>
                        <ModalButton className="modal-button">{"Apply Changes"}<i
                            className="fas fa-chevron-right"></i></ModalButton>
                    <CancelButton onClick={() => {
                        this.setState({modal_open: null})
                    }}>Cancel</CancelButton>
                    </form>
                </AccountModal>

                <NewModal
                    id="timezone-modal"
                    open={this.state.timezone_modal_open}>
                    <DraggableHeader id="timezone-modal-header"></DraggableHeader>
                    <form onSubmit={this.handleTimezoneSubmit}>
                        <MenuClose
                            onClick={() => {
                                this.setState({
                                    'timezone_modal_open': false
                                });
                                this.setOpenMenu(null);
                                this.props.closeDeleteSessionModal();
                            }}
                        >
                            <img src={OnboardingCloseIcon} alt=""/>
                        </MenuClose>
                        <NewModalHeading>SET YOUR TIMEZONE</NewModalHeading>
                        <p>It looks like you've never set your timezone. Please select from the options below (you can
                            also change this at any time in More > Account):</p>

                        <AccountModalSubHeading>Timezone</AccountModalSubHeading>
                        <AccountModalSelect
                            id="timezone"
                            name="timezone"
                            value={this.state.edit_timezone || ''}
                            onChange={(event) => {
                                this.setState({edit_timezone: event.target.value})
                            }}>
                            {timezones.map(timezone => (
                                <option key={timezone} value={timezone}>{timezone}</option>
                            ))}
                        </AccountModalSelect>
                        <br/>
                        <ModalButton className="modal-button">{"Apply Changes"}<i
                            className="fas fa-chevron-right"></i></ModalButton>

                    </form>
                </NewModal>

                <NewModal
                    id="lesson-modal"
                    open={this.props.deleteSessionId && this.props.deletedSession}>
                    <DraggableHeader id="lesson-modal-header"></DraggableHeader>
                    <form onSubmit={this.handleCreateSessionSubmit}>
                        <MenuClose
                            onClick={() => {
                                this.setOpenMenu(null);
                                this.props.closeDeleteSessionModal();
                            }}
                        >
                            <img src={OnboardingCloseIcon} alt=""/>
                        </MenuClose>
                        <NewModalHeading>DELETE LESSON</NewModalHeading>
                        {this.props.deletedSession ? (<>

                            <NewLessonName>{this.props.deletedSession ? this.props.deletedSession.name : ''}</NewLessonName>
                            <WellWrapper>
                                <IconWell>
                                    <div className="fa fa-clock"></div>
                                </IconWell>
                                <ModalInputWell>
                                    <ModalLessonTrigger>
                                        {this.props.deletedSession ? (
                                            <>
                                                {this.state.user_timezone ? (() => {
                                                    let scheduledTime = moment(this.props.deletedSession.scheduled_at).tz(this.state.user_timezone);
                                                    if (!moment(this.props.deletedSession.created_at).tz(this.state.user_timezone).isDST() && moment(this.props.deletedSession.scheduled_at).tz(this.state.user_timezone).isDST()) {
                                                        scheduledTime = scheduledTime.subtract(1, 'hour');
                                                    }
                                                    return (
                                                        <>
                                                            {scheduledTime.format('dddd, MMMM D')}
                                                            <br/>
                                                            {scheduledTime.format('h:mm a')}
                                                        </>
                                                    );
                                                })() : (
                                                    <>
                                                        {this.props.deletedSession.date_line_one}
                                                        <br/>
                                                        {this.props.deletedSession.date_line_two}
                                                    </>
                                                )}
                                            </>
                                        ) : ''}
                                    </ModalLessonTrigger>
                                    {!deletedSessionIsRepeatOrChild ?
                                        <ModalInfo>Event Does Not Repeat</ModalInfo> : <>Event Repeats</>}
                                    <ModalInfo>{this.state.user_timezone}</ModalInfo>
                            </ModalInputWell>
                        </WellWrapper>


                        <WellWrapper>
                            <IconWell>
                                <div className="fa fa-user"></div>
                            </IconWell>
                            <ModalInputWell>
                                <StudentBubble>{this.props.deletedSession.participant_string}</StudentBubble>
                            </ModalInputWell>
                        </WellWrapper>

                            {this.props.deletedSession.description ? (
                                <WellWrapper>
                                    <IconWell>
                                        <div className="fa fa-align-left"></div>
                                    </IconWell>
                                    <ModalInputWell>
                                        <NewLessonDescription>{this.props.deletedSession.description}</NewLessonDescription>
                                    </ModalInputWell>
                                </WellWrapper>
                            ) : <></>}


                            {!deletedSessionIsRepeatOrChild ? (
                                <></>
                            ) : <>
                                <WellWrapper>
                                    <h3 style={{color: '#5562C0', fontSize: '18px', margin: '10px 0', fontWeight: 'bold'}}>
                                        Recurring Options:
                                    </h3>
                                    <IconWell>
                                        <ModalCheckboxInput
                                            id="delete_all_recurring"
                                            type="checkbox"
                                            value={this.state.delete_all_recurring}
                                            onChange={(event) => {
                                                this.setState({delete_all_recurring: event.target.checked})
                                            }}
                                        />
                                    </IconWell>
                                    <ModalInputWell>
                                        <label htmlFor="delete_all_recurring">
                                            Delete all recurring lessons?
                                        </label>
                                    </ModalInputWell>
                                </WellWrapper>
                            </>}

                            <hr/>
                            <br/>
                            <br/>

                            <ModalButton onClick={() => {
                                api().delete('/sessions/' + this.props.deletedSession.uuid+ '?delete_all_recurring='+this.state.delete_all_recurring).then((response) => {
                                    this.props.fetchLessons();
                                    this.props.closeDeleteSessionModal();

                                toast.success('Success! Session deleted!', {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                });
                            })
                        }} className="right-align"
                                     disabled={this.state.session_saving}>
                            Delete
                        </ModalButton>

                        <ModalButton hidden={true} className="outline right-align">Edit Lesson</ModalButton>
                    </>) : (<></>)}

                    </form>
                </NewModal>

                <NewModal
                    id="lesson-modal"
                    open={false}>
                    <DraggableHeader id="lesson-modal-header"></DraggableHeader>
                    <form onSubmit={this.handleCreateSessionSubmit}>
                        <MenuClose
                            onClick={() => {
                                this.setOpenMenu(null);
                                this.props.closeSessionModal();
                            }}
                        >
                            <img src={OnboardingCloseIcon} alt=""/>
                        </MenuClose>
                        <NewModalHeading>All Participants: Host View</NewModalHeading>

                        <NewModalLessonHeading>ADD PARTICIPANT</NewModalLessonHeading>
                        <WellWrapper>
                            <IconWell>
                                <div className="fa fa-user"></div>
                            </IconWell>
                            <ModalInputWell>

                                <NewModalSelect>
                                    <ModalOption>{"Select Student"}</ModalOption>
                                </NewModalSelect>
                                <NewModalRecurringSessionEmailInviteInput placeholder="or Invite by Email"/>
                            </ModalInputWell>
                        </WellWrapper>
                        <hr/>
                        <NewModalLessonHeading>IN CALL</NewModalLessonHeading>
                        <CallListUser>
                            <span className="call-list-initials">JH</span>
                            <span className="call-list-name">Jackson Harris (You, Host)</span>
                            <span className="call-list-actions">
                            <span className="call-list-action">
                                <i className="fa fa-microphone"></i>
                            </span>
                            <span className="call-list-action">
                                <i className="fa fa-camera"></i>
                            </span>
                            <span className="call-list-action">
                                <i className="fa fa-sign-out"></i>
                            </span>
                        </span>
                        </CallListUser>
                        <CallListUser>
                            <span className="call-list-initials">LA</span>
                            <span className="call-list-name">Lily Andy</span>
                            <span className="call-list-actions">
                            <span className="call-list-action toggled">
                                <i className="fa fa-microphone-slash"></i>
                            </span>
                            <span className="call-list-action">
                                <i className="fa fa-camera"></i>
                            </span>
                            <span className="call-list-action">
                                <i className="fa fa-sign-out"></i>
                            </span>
                        </span>
                        </CallListUser>
                    <CallListNote>As host, muting and hiding cameras, hides/mutes the user for everyone in the
                        lesson.
                            <a href="#">Dismiss</a></CallListNote>
                        <hr/>
                        <NewModalLessonHeading>INVITED</NewModalLessonHeading>
                        <CallListUser>
                            <span className="call-list-initials">JJ</span>
                            <span className="call-list-name">Jessi James</span>
                            <span className="call-list-actions">
                            <span className="call-list-action purple">
                                REMIND
                            </span>
                        </span>
                        </CallListUser>
                        <CallListUser>
                            <span className="call-list-initials">LL</span>
                            <span className="call-list-name">Lux Lighthouse</span>
                            <span className="call-list-actions">
                            <span className="call-list-action purple">
                                REMIND
                            </span>
                        </span>
                        </CallListUser>
                        <br/>
                        <br/>


                        <ModalButton className="outline right-align">Close</ModalButton>


                    </form>
                </NewModal>


                <NewModal
                    id="lesson-modal"
                    open={this.state.modal_open == 'lesson-review'}>
                    <DraggableHeader id="lesson-modal-header"></DraggableHeader>
                    <form onSubmit={this.handleCreateSessionSubmit}>
                        <MenuClose
                            onClick={() => {
                                this.setOpenMenu(null);
                                this.props.closeSessionModal();
                            }}
                        >
                            <img src={OnboardingCloseIcon} alt=""/>
                        </MenuClose>
                        <NewModalHeading>New Lesson Created</NewModalHeading>

                        <NewLessonName>{this.state.created_session_name}</NewLessonName>
                        <WellWrapper>
                            <IconWell>
                                <div className="fa fa-clock"></div>
                            </IconWell>
                            <ModalInputWell>
                                <ModalLessonTrigger>
                                {this.state.created_session_datetime ? (<>
                                            {this.state.created_session_datetime.format('dddd, MMMM Do')}
                                            <br/>
                                            {this.state.created_session_datetime.format('h:mm:ss a')}
                                </>) : ''}
                                </ModalLessonTrigger>
                                {this.state.created_repeat ? <ModalInfo>Event Does Not Repeat</ModalInfo> : <></>}
                                <ModalInfo>{this.state.user_timezone}</ModalInfo>
                            </ModalInputWell>
                        </WellWrapper>


                        <WellWrapper>
                            <IconWell>
                                <div className="fa fa-user"></div>
                            </IconWell>
                            <ModalInputWell>
                                <StudentBubble>{this.state.created_student_name}</StudentBubble>
                            </ModalInputWell>
                        </WellWrapper>

                        <WellWrapper>
                            <IconWell>
                                <div className="fa fa-align-left"></div>
                            </IconWell>
                            <ModalInputWell>
                                <NewLessonDescription>{this.state.created_session_description}</NewLessonDescription>
                            </ModalInputWell>
                        </WellWrapper>
                        <hr/>
                        <br/>
                        <br/>

                    <ModalButton type="button" onClick={() => {
                        this.setState({modal_open: null})
                    }} className="right-align"
                                     disabled={this.state.session_saving}>
                            Done
                        </ModalButton>

                        <ModalButton type="button" hidden={true} className="outline right-align">Edit Lesson</ModalButton>
                    </form>
                </NewModal>


                <NewModal
                    id="lesson-modal"
                    open={this.props.isSessionModalOpen}>
                    <DraggableHeader id="lesson-modal-header"></DraggableHeader>
                    <form onSubmit={this.handleCreateSessionSubmit}>
                        <MenuClose
                            onClick={() => {
                                this.setOpenMenu(null);
                                this.props.closeSessionModal();
                            }}
                        >
                            <img src={OnboardingCloseIcon} alt=""/>
                        </MenuClose>
                        <NewModalHeading>{"Create New Lesson"}</NewModalHeading>
                        <ErrorAlert
                            hidden={this.state.session_creation_error == null}>{this.state.session_creation_error}</ErrorAlert>

                    <NewModalLessonHeading>LESSON TITLE</NewModalLessonHeading>
                    <WellWrapper>
                        <NewModalInput
                            className="modal-input"
                            onChange={e => this.setState({lesson_name: e.target.value})}
                            value={this.state.lesson_name || ''}
                            type="text" placeholder="Name Your Lesson"/>
                    </WellWrapper>
                    <br/>
                    <WellWrapper>
                        <IconWell>
                            <div className="fa fa-clock"></div>
                        </IconWell>
                        <ModalInputWell>
                            <ModalLessonTrigger>
                                {this.state.session_datetime ? (<>
                                            {this.state.session_datetime.format('dddd, MMMM Do')}
                                            <br/>
                                            {this.state.session_datetime.format('h:mm:ss a')}
                                </>) : 'Select a Date and Time'}
                                    <MuzeDatetime
                                        key={this.state.session_form_key}
                                        value={this.state.session_datetime}
                                        onChange={this.handleCreateSessionStudentDatetimeInputChange}
                                    ></MuzeDatetime>
                                </ModalLessonTrigger>

                                <NewModalSimpleSelect onChange={this.handleRecurringSessionTypeChange}
                                                      value={this.state.recurring_session_type}>
                                    <option value="">Event Does Not Repeat</option>
                                    <option value="repeat-weekly">Repeat Weekly</option>
                                    <option value="repeat-daily">Repeat Daily</option>
                                </NewModalSimpleSelect>

                                <NewModalSimpleSelect hidden={true}>
                                    <option value="">Add Timezone</option>
                                </NewModalSimpleSelect>
                                <RecurringSessionDaysInput
                                    hidden={this.state.recurring_session_type == null || this.state.recurring_session_type == ''}
                                    onChange={this.handleRecurringSessionDaysInputChange}
                                    value={this.state.recurring_session_occurrences} type="number"
                                    min="1"
                                    placeholder="# of Occurrences to Repeat"></RecurringSessionDaysInput>
                            </ModalInputWell>
                        </WellWrapper>


                        <WellWrapper>
                            <IconWell>
                                <div className="fa fa-user"></div>
                            </IconWell>
                            <ModalInputWell>
                                <MultiSelect
                                    required
                                    options={this.state.student_options}
                                    onChange={(e) => {
                                        this.setState({student_ids: e})
                                    }}
                                    value={this.state.student_ids}
                                    labelledBy={"Select"}
                                    autosize={true}
                                />
                                <br/>
                                <NewModalRecurringSessionEmailInviteInput
                                    name="email_invite"
                                    value={this.state.recurring_session_email_invite}
                                    onChange={this.handleRecurringSessionEmailInviteInputChange}
                                    placeholder="or Invite by Email"/>

                                <NewModalSimpleSelect hidden={true}>
                                    <option value="">Select Class List</option>
                                </NewModalSimpleSelect>

                                <NewModalSimpleAddButton hidden={true}>
                                    Save Class List <i className="fa fa-plus"></i>
                                </NewModalSimpleAddButton>
                            </ModalInputWell>
                        </WellWrapper>
                        <hr/>

                        <WellWrapper>
                            <IconWell>
                                <div className="fa fa-align-left"></div>
                            </IconWell>
                            <ModalInputWell>
                                <NewModalTextArea
                                    className="modal-description"
                                    onChange={this.handleLessonDescriptionInputChange}
                                    value={this.state.lesson_description || ''}
                                    placeholder="Add a description of the lesson.">
                                </NewModalTextArea>
                            </ModalInputWell>
                        </WellWrapper>

                    <CancelButton onClick={() => {
                        this.setOpenMenu(null);
                        this.props.closeSessionModal();
                    }}
                    >Cancel</CancelButton>

                        <ModalButton className="right-align" disabled={this.state.session_saving}>
                        {this.state.session_saving ? "Saving..." : "Create Lesson"}
                        </ModalButton>

                        <ModalButton type="button" hidden={true} className="outline right-align">Save Draft</ModalButton>
                    </form>
                </NewModal>

                <Modal id="note-modal"
                   open={this.state.modal_open === "note" || this.state.modal_open === "lesson_note"}
            >
                <DraggableHeader id="note-modal-header"></DraggableHeader>
                <ModalClose style={{right:'38px'}} title={this.state.note_minimized ? 'Restore' : 'Minimize'} onClick={this.toggleNoteMinimized}>{this.state.note_minimized ? '▢' : '–'}</ModalClose>
                <ModalClose onClick={() => {
                    this.setState({modal_open: null, note_minimized: false})
                }}>X</ModalClose>
                {this.state.note_minimized && (
                    <div style={{textAlign:'left',fontWeight:'bold',padding:'8px 70px 8px 0',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
                        {this.state.note_name || 'Untitled note'}
                    </div>
                )}
                {!this.state.note_minimized && (
                <form onSubmit={this.handleCreateNoteSubmit}>
                    {this.state.note_draft_available && (
                        <div style={{background:'#fff3cd',border:'1px solid #ffc107',borderRadius:'4px',padding:'8px 12px',marginBottom:'10px',fontSize:'13px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                            <span>Draft restored from a previous session.</span>
                            <button type="button" onClick={this.dismissNoteDraft} style={{background:'none',border:'none',cursor:'pointer',fontWeight:'bold',fontSize:'14px',padding:'0 4px'}}>×</button>
                        </div>
                    )}
                    <ModalHeading>{note_modal_heading}</ModalHeading>

                        <MultiSelectWrapper>
                            <ModalSubheading>Want to assign to a {add_text} or {add_text}s?</ModalSubheading>
                            <MultiSelect
                                required
                                options={this.state.student_options}
                                onChange={(e) => {
                                    this.setState({selectedNoteStudents: e})
                                }}
                                value={this.state.selectedNoteStudents}
                                labelledBy={"Select"}
                            />
                        </MultiSelectWrapper>

                        <ModalInput
                            value={this.state.note_name}
                            onChange={this.handleCreateNoteNameInputChange}
                            placeholder="Enter Note Name"
                        ></ModalInput>
                        <RichTextEditor
                            toolbarConfig={toolbarConfig}
                            className="rte"
                            value={this.state.note_content}
                            onChange={this.handleCreateNoteContentInputChange}
                        ></RichTextEditor>
                        <br/>

                        <ModalButton>{"Save Note"}</ModalButton>
                    </form>
                )}
                </Modal>

                <Modal id="note-edit-modal"
                   open={this.state.modal_open === "note-edit"}
            >
                <DraggableHeader id="note-edit-modal-header"></DraggableHeader>
                <ModalClose style={{right:'38px'}} title={this.state.note_minimized ? 'Restore' : 'Minimize'} onClick={this.toggleNoteMinimized}>{this.state.note_minimized ? '▢' : '–'}</ModalClose>
                <ModalClose onClick={() => {
                    this.setState({modal_open: null, note_minimized: false})
                }}>X</ModalClose>
                {this.state.note_minimized && (
                    <div style={{textAlign:'left',fontWeight:'bold',padding:'8px 70px 8px 0',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
                        {this.state.edit_note_name || 'Untitled note'}
                    </div>
                )}
                {!this.state.note_minimized && (<>
                {!this.state.view_note ? (<>
                    <form onSubmit={this.handleEditNoteSubmit}>
                        <ModalHeading>
                            {this.state.view_note ? 'View Note' : 'Edit Note'}
                            {this.state.edit_note_save_status === 'saving' && <span style={{fontSize:'12px',fontWeight:'normal',color:'#888',marginLeft:'10px'}}>Saving...</span>}
                            {this.state.edit_note_save_status === 'saved' && <span style={{fontSize:'12px',fontWeight:'normal',color:'#28a745',marginLeft:'10px'}}>Saved</span>}
                            {this.state.edit_note_save_status === 'error' && <span style={{fontSize:'12px',fontWeight:'normal',color:'#dc3545',marginLeft:'10px'}}>Save failed</span>}
                        </ModalHeading>
                        <MultiSelectWrapper>
                            <ModalSubheading>Want to assign to a {add_text} or {add_text}s?</ModalSubheading>
                            <MultiSelect
                                required
                                options={this.state.student_options}
                                onChange={(e) => {
                                    this.setState({selectedEditNoteStudents: e})
                                }}
                                value={this.state.selectedEditNoteStudents}
                                labelledBy={"Select"}
                            />
                        </MultiSelectWrapper>

                                <ModalInput
                                    value={this.state.edit_note_name}
                                    onChange={this.handleEditNoteNameInputChange}
                                    placeholder="Enter Note Name"
                                ></ModalInput>
                                <RichTextEditor
                                    toolbarConfig={toolbarConfig}
                                    className="rte"
                                    value={this.state.edit_note_content}
                                    onChange={this.handleEditNoteContentInputChange}
                                ></RichTextEditor>
                                <br/>
                                <ModalButton>{"Save Note"}</ModalButton>
                            </form>
                </>) : (<>

                    <ModalHeading>View Note</ModalHeading>
                    <ModalInput
                        disabled="true"
                        readonly="true"
                        value={this.state.edit_note_name}
                        placeholder="Enter Note Name"
                    ></ModalInput>
                    <div onClick={this.handleNoteLinkClick}>
                        <RichTextEditor
                            disabled="true"
                            readonly="true"
                            className="rte"
                            value={this.state.edit_note_content}
                        ></RichTextEditor>
                    </div>
                    <br/>
                </>)}
                </>)}

                </Modal>

                <Modal id="clip-edit-modal"
                   open={this.state.modal_open === "clip-edit"}
            >
                <DraggableHeader id="clip-edit-modal-header"></DraggableHeader>
                <ModalClose onClick={() => {
                    this.setState({modal_open: null})
                }}>X</ModalClose>
                <form onSubmit={this.handleEditClipSubmit}>
                    <ModalHeading>Edit Clip Name</ModalHeading>

                        <MultiSelectWrapper>
                            <ModalSubheading>Want to assign to a {add_text} or {add_text}s?</ModalSubheading>
                            <MultiSelect
                                required
                                options={this.state.student_options}
                                onChange={(e) => {
                                    this.setState({selectedEditClipStudents: e})
                                }}
                                value={this.state.selectedEditClipStudents}
                                labelledBy={"Select"}
                            />
                        </MultiSelectWrapper>
                        <ModalInput
                            value={this.state.edit_clip_name}
                            onChange={this.handleEditClipNameInputChange}
                            placeholder="Enter Clip Name"
                        ></ModalInput>
                        <br/>
                        <ModalButton>{"Save Clip"}</ModalButton>
                    </form>
                </Modal>

                <Modal id="file-edit-modal"
                   open={this.state.modal_open === "file-edit"}
            >
                <DraggableHeader id="file-edit-modal-header"></DraggableHeader>
                <ModalClose onClick={() => {
                    this.setState({modal_open: null})
                }}>X</ModalClose>
                <form onSubmit={this.handleEditFileSubmit}>
                    {this.state.share_heading ? (<ModalHeading>Share File</ModalHeading>) : (
                        <ModalHeading>Edit File Name</ModalHeading>)}


                        <MultiSelectWrapper>
                            <ModalSubheading>Want to assign to a {add_text} or {add_text}s?</ModalSubheading>
                            <MultiSelect
                                required
                                options={this.state.student_options}
                                onChange={(e) => {
                                    this.setState({selectedEditFileStudents: e})
                                }}
                                value={this.state.selectedEditFileStudents}
                                labelledBy={"Select"}
                            />
                        </MultiSelectWrapper>
                        {this.state.share_heading ? (<></>) : (<ModalInput
                            value={this.state.edit_file_name}
                            onChange={this.handleEditFileNameInputChange}
                            placeholder="Enter File Name"
                        ></ModalInput>)}

                        <br/>
                        <ModalButton>{"Save File"}</ModalButton>
                    </form>
                </Modal>

                <Modal id="file-modal"
                   open={this.state.modal_open === "file" || this.state.modal_open === "lesson_file"}
            >
                <DraggableHeader id="file-modal-header"></DraggableHeader>
                <ModalClose onClick={() => {
                    this.setState({modal_open: null})
                }}>X</ModalClose>
                <form onSubmit={this.handleCreateFileSubmit}>
                    <ModalHeading>{file_modal_heading}</ModalHeading>

                    {this.state.file_creation_error ? (<><OrangeError><i
                        className="fas fa-exclamation-triangle"></i>{this.state.file_creation_error}
                    </OrangeError><br/></>) : (<></>)}


                        <MultiSelectWrapper>
                            <ModalSubheading>Want to assign to a {add_text} or {add_text}s?</ModalSubheading>
                            <MultiSelect
                                required
                                options={this.state.student_options}
                                onChange={(e) => {
                                    this.setState({selectedFileStudents: e})
                                }}
                                value={this.state.selectedFileStudents}
                                labelledBy={"Select"}
                            />
                        </MultiSelectWrapper>

                        <ModalInput
                            placeholder="Enter File Name"
                            value={this.state.file_name}
                            onChange={this.handleCreateFileNameInputChange}
                        ></ModalInput>
                        <ModalFileInput
                            className="file-input" type="file" onChange={this.handleFileInputChange}></ModalFileInput>
                        <p>File limit of 100MB.</p>
                        <p>File types supported: jpeg,bmp,png,doc,docx,csv,xls,xlsx,pdf</p>
                        <br/>
                        <ModalButton>{"Save File"}</ModalButton>
                    </form>
                </Modal>

                <Modal id="file-modal"
                   open={this.state.chrome_modal_open}
            >
                <DraggableHeader id="file-modal-header"></DraggableHeader>
                <ModalClose onClick={() => {
                    this.setState({chrome_modal_open: false})
                }}>X</ModalClose>

                    <ModalHeading>For Best Experience</ModalHeading>

                    <MultiSelectWrapper>
                        <ModalSubheading>Please use Muze on Chrome</ModalSubheading>
                    </MultiSelectWrapper>


                </Modal>


                <OnboardingModal open={this.state.onboarding_step !== null}>
                <OnboardingClose onClick={() => {
                    this.setState({onboarding_step: null})
                }}><img src={OnboardingCloseIcon}
                        alt=""/></OnboardingClose>

                    <OnboardingModalStep open={this.state.onboarding_step == 1}>
                        <OnboardingModalLeft>
                            <h2>Welcome to Muze!</h2>
                            <p>Let's get started by walking through a few major features.</p>
                            <ol>
                            {(this.props.isInstructor) ? <li><a onClick={() => {
                                this.setState({onboarding_step: 2})
                            }}>Scheduling a Lesson</a>
                            </li> : ''}
                            <li><a onClick={() => {
                                this.setState({onboarding_step: 5})
                            }}>Recording Clips</a></li>
                            <li><a onClick={() => {
                                this.setState({onboarding_step: 10})
                            }}>Using the Metronome</a></li>
                            <li><a onClick={() => {
                                this.setState({onboarding_step: 13})
                            }}>Using the Tuner</a></li>
                            </ol>
                            <small>Other questions? <a target="_blank" href="https://learnwithmuze.com/faqs/">Visit our
                                FAQ</a></small>
                        </OnboardingModalLeft>
                        <OnboardingModalRight>
                            <OnboardingModalImage background={ObStep1}></OnboardingModalImage>
                        </OnboardingModalRight>
                        <OnboardingModalButtons>
                            <OnboardingModalSkip
                            onClick={() => {
                                this.setState({onboarding_step: null})
                            }}>Skip</OnboardingModalSkip>
                            <OnboardingModalNext
                            onClick={() => {
                                this.setState({onboarding_step: this.props.isInstructor ? ++this.state.onboarding_step : 5})
                            }}>Next
                                <img src={ChevronRightWhite} alt=""/></OnboardingModalNext>
                        </OnboardingModalButtons>
                    </OnboardingModalStep>

                    <OnboardingModalStep open={this.state.onboarding_step == 2}>
                        <OnboardingModalLeft>
                            <OnboardingSteps><OnboardingCurrentStep>1</OnboardingCurrentStep> of 3</OnboardingSteps>
                            <h2>Scheduling Lessons</h2>
                            <p>Get started scheduling lessons by clicking the plus button on the main screen.</p>
                        </OnboardingModalLeft>
                        <OnboardingModalRight>
                            <OnboardingModalImage background={ObStep2}></OnboardingModalImage>
                        </OnboardingModalRight>
                        <OnboardingModalButtons>
                            <OnboardingModalSkip
                            onClick={() => {
                                this.setState({onboarding_step: --this.state.onboarding_step})
                            }}>Back</OnboardingModalSkip>
                            <OnboardingModalNext
                            onClick={() => {
                                this.setState({onboarding_step: ++this.state.onboarding_step})
                            }}>Next
                                <img src={ChevronRightWhite} alt=""/></OnboardingModalNext>
                        </OnboardingModalButtons>
                        <OnboardingDots>
                            <OnboardingDot active={true}></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                        </OnboardingDots>
                    </OnboardingModalStep>

                    <OnboardingModalStep open={this.state.onboarding_step == 3}>
                        <OnboardingModalLeft>
                            <OnboardingSteps><OnboardingCurrentStep>2</OnboardingCurrentStep> of 3</OnboardingSteps>
                            <h2>Scheduling Lessons</h2>
                            <p className="old">Get started scheduling lessons by clicking the plus button on the main
                                screen.</p>
                            <p>Next, you need to add a new student or select from current students.</p>
                        </OnboardingModalLeft>
                        <OnboardingModalRight>
                            <OnboardingModalImage background={ObStep3}></OnboardingModalImage>
                        </OnboardingModalRight>
                        <OnboardingModalButtons>
                            <OnboardingModalSkip
                            onClick={() => {
                                this.setState({onboarding_step: --this.state.onboarding_step})
                            }}>Back</OnboardingModalSkip>
                            <OnboardingModalNext
                            onClick={() => {
                                this.setState({onboarding_step: ++this.state.onboarding_step})
                            }}>Next
                                <img src={ChevronRightWhite} alt=""/></OnboardingModalNext>
                        </OnboardingModalButtons>
                        <OnboardingDots>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot active={true}></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                        </OnboardingDots>
                    </OnboardingModalStep>

                    <OnboardingModalStep open={this.state.onboarding_step == 4}>
                        <OnboardingModalLeft>
                            <OnboardingSteps><OnboardingCurrentStep>3</OnboardingCurrentStep> of 3</OnboardingSteps>
                            <h2>Scheduling Lessons</h2>
                            <p className="old">Get started scheduling lessons by clicking the plus button on the main
                                screen.</p>
                            <p className="old">Next, you need to add a new student or select from current students.</p>
                        <p>Lastly, select a date and time and click Create Lesson. An email invitation will be sent
                            to
                                your student.</p>
                            <small>Other questions? <a href="https://learnwithmuze.com/faqs/">Visit our FAQ</a></small>
                        </OnboardingModalLeft>
                        <OnboardingModalRight>
                            <OnboardingModalImage background={ObStep4}></OnboardingModalImage>
                        </OnboardingModalRight>
                        <OnboardingModalButtons>
                            <OnboardingModalSkip
                            onClick={() => {
                                this.setState({onboarding_step: --this.state.onboarding_step})
                            }}>Back</OnboardingModalSkip>
                            <OnboardingModalNext
                            onClick={() => {
                                this.setState({onboarding_step: ++this.state.onboarding_step})
                            }}>Next:
                                Recording Clips <img src={ChevronRightWhite} alt=""/></OnboardingModalNext>
                        </OnboardingModalButtons>
                        <OnboardingDots>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot active={true}></OnboardingDot>
                        </OnboardingDots>
                    </OnboardingModalStep>

                    <OnboardingModalStep open={this.state.onboarding_step == 5}>
                        <OnboardingModalLeft>
                            <OnboardingSteps><OnboardingCurrentStep>1</OnboardingCurrentStep> of 5</OnboardingSteps>
                            <h2>Recording Clips</h2>
                            <p>Click 'Record Clip' at the top of the toolbar. To create, press 'Create New
                                Lesson Clip'.</p>
                        </OnboardingModalLeft>
                        <OnboardingModalRight>
                            <OnboardingModalImage background={ObStep5}></OnboardingModalImage>
                        </OnboardingModalRight>
                        <OnboardingModalButtons>
                            <OnboardingModalSkip
                            onClick={() => {
                                this.setState({onboarding_step: this.props.isInstructor ? --this.state.onboarding_step : 1})
                            }}>Back</OnboardingModalSkip>
                            <OnboardingModalNext
                            onClick={() => {
                                this.setState({onboarding_step: ++this.state.onboarding_step})
                            }}>Next
                                <img src={ChevronRightWhite} alt=""/></OnboardingModalNext>
                        </OnboardingModalButtons>
                        <OnboardingDots>
                            <OnboardingDot active={true}></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                        </OnboardingDots>
                    </OnboardingModalStep>

                    <OnboardingModalStep open={this.state.onboarding_step == 6}>
                        <OnboardingModalLeft>
                            <OnboardingSteps><OnboardingCurrentStep>2</OnboardingCurrentStep> of 5</OnboardingSteps>
                            <h2>Recording Clips</h2>
                        <p className="old">Click 'Record Clip' at the top of the toolbar. To create, press 'Create
                            New
                                Lesson Clip'.</p>
                            <p>Enter clip name and begin recording. You'll be given a 3 second countdown before the
                                recording starts.</p>
                        </OnboardingModalLeft>
                        <OnboardingModalRight>
                            <OnboardingModalImage background={ObStep6}></OnboardingModalImage>
                        </OnboardingModalRight>
                        <OnboardingModalButtons>
                            <OnboardingModalSkip
                            onClick={() => {
                                this.setState({onboarding_step: --this.state.onboarding_step})
                            }}>Back</OnboardingModalSkip>
                            <OnboardingModalNext
                            onClick={() => {
                                this.setState({onboarding_step: ++this.state.onboarding_step})
                            }}>Next
                                <img src={ChevronRightWhite} alt=""/></OnboardingModalNext>
                        </OnboardingModalButtons>
                        <OnboardingDots>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot active={true}></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                        </OnboardingDots>
                    </OnboardingModalStep>

                    <OnboardingModalStep open={this.state.onboarding_step == 7}>
                        <OnboardingModalLeft>
                            <OnboardingSteps><OnboardingCurrentStep>3</OnboardingCurrentStep> of 5</OnboardingSteps>
                            <h2>Recording Clips</h2>
                        <p className="old">Click 'Record Clip' at the top of the toolbar. To create, press 'Create
                            New
                                Lesson Clip'.</p>
                            <p className="old">Enter clip name and begin recording. You'll be given a 3 second countdown
                                before the recording starts.</p>
                        <p>To end the recording select 'Stop Recording.' This will end the recording and the clip
                            will
                                begin to process and save. DO NOT close Muze until the clip is saved successfully.</p>
                        </OnboardingModalLeft>
                        <OnboardingModalRight>
                            <OnboardingModalImage background={ObStep7}></OnboardingModalImage>
                        </OnboardingModalRight>
                        <OnboardingModalButtons>
                            <OnboardingModalSkip
                            onClick={() => {
                                this.setState({onboarding_step: --this.state.onboarding_step})
                            }}>Back</OnboardingModalSkip>
                            <OnboardingModalNext
                            onClick={() => {
                                this.setState({onboarding_step: ++this.state.onboarding_step})
                            }}>Next
                                <img src={ChevronRightWhite} alt=""/></OnboardingModalNext>
                        </OnboardingModalButtons>
                        <OnboardingDots>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot active={true}></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                        </OnboardingDots>
                    </OnboardingModalStep>

                    <OnboardingModalStep open={this.state.onboarding_step == 8}>
                        <OnboardingModalLeft>
                            <OnboardingSteps><OnboardingCurrentStep>4</OnboardingCurrentStep> of 5</OnboardingSteps>
                            <h2>Recording Clips</h2>
                        <p className="old">Click 'Record Clip' at the top of the toolbar. To create, press 'Create
                            New
                                Lesson Clip'.</p>
                            <p className="old">Enter clip name and begin recording. You'll be given a 3 second countdown
                                before the recording starts.</p>
                        <p className="old">To end the recording select 'Stop Recording.' This will end the recording
                            and
                                the clip will
                                begin to process and save. DO NOT close Muze until the clip is saved successfully.</p>
                            <p>Once saved, Muze will inform you the clip was processed.</p>
                        </OnboardingModalLeft>
                        <OnboardingModalRight>
                            <OnboardingModalImage background={ObStep8}></OnboardingModalImage>
                        </OnboardingModalRight>
                        <OnboardingModalButtons>
                            <OnboardingModalSkip
                            onClick={() => {
                                this.setState({onboarding_step: --this.state.onboarding_step})
                            }}>Back</OnboardingModalSkip>
                            <OnboardingModalNext
                            onClick={() => {
                                this.setState({onboarding_step: ++this.state.onboarding_step})
                            }}>Next
                                <img src={ChevronRightWhite} alt=""/></OnboardingModalNext>
                        </OnboardingModalButtons>
                        <OnboardingDots>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot active={true}></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                        </OnboardingDots>
                    </OnboardingModalStep>

                    <OnboardingModalStep open={this.state.onboarding_step == 9}>
                        <OnboardingModalLeft>
                            <OnboardingSteps><OnboardingCurrentStep>5</OnboardingCurrentStep> of 5</OnboardingSteps>
                            <h2>Recording Clips</h2>
                        <p className="old">Click 'Record Clip' at the top of the toolbar. To create, press 'Create
                            New
                                Lesson Clip'.</p>
                            <p className="old">Enter clip name and begin recording. You'll be given a 3 second countdown
                                before the recording starts.</p>
                        <p className="old">To end the recording select 'Stop Recording.' This will end the recording
                            and
                                the clip will
                                begin to process and save. DO NOT close Muze until the clip is saved successfully.</p>
                            <p className="old">Once saved, Muze will inform you the clip was processed.</p>
                            <p>For best results, we recommend both parties use headphones to avoid sound bleed between
                                devices.</p>
                            <small>Other questions? <a href="https://learnwithmuze.com/faqs/">Visit our FAQ</a></small>
                        </OnboardingModalLeft>
                        <OnboardingModalRight>
                            <OnboardingModalImage background={ObStep9}></OnboardingModalImage>
                        </OnboardingModalRight>
                        <OnboardingModalButtons>
                            <OnboardingModalSkip
                            onClick={() => {
                                this.setState({onboarding_step: --this.state.onboarding_step})
                            }}>Back</OnboardingModalSkip>
                            <OnboardingModalNext
                            onClick={() => {
                                this.setState({onboarding_step: ++this.state.onboarding_step})
                            }}>Next: Using
                                the Metronome <img src={ChevronRightWhite} alt=""/></OnboardingModalNext>
                        </OnboardingModalButtons>
                        <OnboardingDots>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot active={true}></OnboardingDot>
                        </OnboardingDots>
                    </OnboardingModalStep>

                    <OnboardingModalStep open={this.state.onboarding_step == 10}>
                        <OnboardingModalLeft>
                            <OnboardingSteps><OnboardingCurrentStep>1</OnboardingCurrentStep> of 3</OnboardingSteps>
                            <h2>Using the Metronome</h2>
                            <p>To use the metronome, start by selecting the metronome icon.</p>
                        </OnboardingModalLeft>
                        <OnboardingModalRight>
                            <OnboardingModalImage background={ObStep10}></OnboardingModalImage>
                        </OnboardingModalRight>
                        <OnboardingModalButtons>
                            <OnboardingModalSkip
                            onClick={() => {
                                this.setState({onboarding_step: --this.state.onboarding_step})
                            }}>Back</OnboardingModalSkip>
                            <OnboardingModalNext
                            onClick={() => {
                                this.setState({onboarding_step: ++this.state.onboarding_step})
                            }}>Next
                                <img src={ChevronRightWhite} alt=""/></OnboardingModalNext>
                        </OnboardingModalButtons>
                        <OnboardingDots>
                            <OnboardingDot active={true}></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                        </OnboardingDots>
                    </OnboardingModalStep>

                    <OnboardingModalStep open={this.state.onboarding_step == 11}>
                        <OnboardingModalLeft>
                            <OnboardingSteps><OnboardingCurrentStep>2</OnboardingCurrentStep> of 3</OnboardingSteps>
                            <h2>Using the Metronome</h2>
                            <p className="old">To use the metronome, start by selecting the metronome icon.</p>
                            <p>Next, input a BPM (beats per minute) value by clicking the input field and typing.</p>
                        </OnboardingModalLeft>
                        <OnboardingModalRight>
                            <OnboardingModalImage background={ObStep11}></OnboardingModalImage>
                        </OnboardingModalRight>
                        <OnboardingModalButtons>
                            <OnboardingModalSkip
                            onClick={() => {
                                this.setState({onboarding_step: --this.state.onboarding_step})
                            }}>Back</OnboardingModalSkip>
                            <OnboardingModalNext
                            onClick={() => {
                                this.setState({onboarding_step: ++this.state.onboarding_step})
                            }}>Next
                                <img src={ChevronRightWhite} alt=""/></OnboardingModalNext>
                        </OnboardingModalButtons>
                        <OnboardingDots>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot active={true}></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                        </OnboardingDots>
                    </OnboardingModalStep>

                    <OnboardingModalStep open={this.state.onboarding_step == 12}>
                        <OnboardingModalLeft>
                            <OnboardingSteps><OnboardingCurrentStep>3</OnboardingCurrentStep> of 3</OnboardingSteps>
                            <h2>Using the Metronome</h2>
                            <p className="old">To use the metronome, start by selecting the metronome icon.</p>
                        <p className="old">Next, input a BPM (beats per minute) value by clicking the input field
                            and
                                typing.</p>
                            <p>Finally, press the play button to begin the metronome.</p>
                            <small>Other questions? <a href="https://learnwithmuze.com/faqs/">Visit our FAQ</a></small>
                        </OnboardingModalLeft>
                        <OnboardingModalRight>
                            <OnboardingModalImage background={ObStep12}></OnboardingModalImage>
                        </OnboardingModalRight>
                        <OnboardingModalButtons>
                            <OnboardingModalSkip
                            onClick={() => {
                                this.setState({onboarding_step: --this.state.onboarding_step})
                            }}>Back</OnboardingModalSkip>
                            <OnboardingModalNext
                            onClick={() => {
                                this.setState({onboarding_step: ++this.state.onboarding_step})
                            }}>Next: Using
                                the Tuner <img src={ChevronRightWhite} alt=""/></OnboardingModalNext>
                        </OnboardingModalButtons>
                        <OnboardingDots>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot active={true}></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                        </OnboardingDots>
                    </OnboardingModalStep>

                    <OnboardingModalStep open={this.state.onboarding_step == 13}>
                        <OnboardingModalLeft>
                            <OnboardingSteps><OnboardingCurrentStep>1</OnboardingCurrentStep> of 4</OnboardingSteps>
                            <h2>Using the Tuner</h2>
                            <p>To use the tuner, select the tuner icon on the left hand menu.</p>
                        </OnboardingModalLeft>
                        <OnboardingModalRight>
                            <OnboardingModalImage background={ObStep13}></OnboardingModalImage>
                        </OnboardingModalRight>
                        <OnboardingModalButtons>
                            <OnboardingModalSkip
                            onClick={() => {
                                this.setState({onboarding_step: --this.state.onboarding_step})
                            }}>Back</OnboardingModalSkip>
                            <OnboardingModalNext
                            onClick={() => {
                                this.setState({onboarding_step: ++this.state.onboarding_step})
                            }}>Next <img
                                src={ChevronRightWhite} alt=""/></OnboardingModalNext>
                        </OnboardingModalButtons>
                        <OnboardingDots>
                            <OnboardingDot active={true}></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                        </OnboardingDots>
                    </OnboardingModalStep>

                    <OnboardingModalStep open={this.state.onboarding_step == 14}>
                        <OnboardingModalLeft>
                            <OnboardingSteps><OnboardingCurrentStep>2</OnboardingCurrentStep> of 4</OnboardingSteps>
                            <h2>Using the Tuner</h2>
                            <p className="old">To use the tuner, select the tuner icon on the left hand menu.</p>
                            <p>Play a note using your instrument of choice, and allow the tool to detect the note.</p>
                        </OnboardingModalLeft>
                        <OnboardingModalRight>
                            <OnboardingModalImage background={ObStep14}></OnboardingModalImage>
                        </OnboardingModalRight>
                        <OnboardingModalButtons>
                            <OnboardingModalSkip
                            onClick={() => {
                                this.setState({onboarding_step: --this.state.onboarding_step})
                            }}>Back</OnboardingModalSkip>
                            <OnboardingModalNext
                            onClick={() => {
                                this.setState({onboarding_step: ++this.state.onboarding_step})
                            }}>Next <img
                                src={ChevronRightWhite} alt=""/></OnboardingModalNext>
                        </OnboardingModalButtons>
                        <OnboardingDots>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot active={true}></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                        </OnboardingDots>
                    </OnboardingModalStep>

                    <OnboardingModalStep open={this.state.onboarding_step == 15}>
                        <OnboardingModalLeft>
                            <OnboardingSteps><OnboardingCurrentStep>3</OnboardingCurrentStep> of 4</OnboardingSteps>
                            <h2>Using the Tuner</h2>
                            <p className="old">To use the tuner, select the tuner icon on the left hand menu.</p>
                        <p className="old">Play a note using your instrument of choice, and allow the tool to detect
                            the
                                note.</p>
                        <p>Once the tuner recognizes the note, try to adjust it so it stays steady and in the center
                            of
                                the dial.</p>
                        </OnboardingModalLeft>
                        <OnboardingModalRight>
                            <OnboardingModalImage background={ObStep15}></OnboardingModalImage>
                        </OnboardingModalRight>
                        <OnboardingModalButtons>
                            <OnboardingModalSkip
                            onClick={() => {
                                this.setState({onboarding_step: --this.state.onboarding_step})
                            }}>Back</OnboardingModalSkip>
                            <OnboardingModalNext
                            onClick={() => {
                                this.setState({onboarding_step: ++this.state.onboarding_step})
                            }}>Next <img
                                src={ChevronRightWhite} alt=""/></OnboardingModalNext>
                        </OnboardingModalButtons>
                        <OnboardingDots>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot active={true}></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                        </OnboardingDots>
                    </OnboardingModalStep>

                    <OnboardingModalStep open={this.state.onboarding_step == 16}>
                        <OnboardingModalLeft>
                            <OnboardingSteps><OnboardingCurrentStep>4</OnboardingCurrentStep> of 4</OnboardingSteps>
                            <h2>Using the Tuner</h2>
                            <p className="old">To use the tuner, select the tuner icon on the left hand menu.</p>
                        <p className="old">Play a note using your instrument of choice, and allow the tool to detect
                            the
                                note.</p>
                        <p className="old">Once the tuner recognizes the note, try to adjust it so it stays steady
                            and
                                in the center of the dial.</p>
                        <p>The note is properly tuned when the dial stays steady over the green area in the
                            center.</p>
                            <small>Other questions? <a href="https://learnwithmuze.com/faqs/">Visit our FAQ</a></small>
                        </OnboardingModalLeft>
                        <OnboardingModalRight>
                            <OnboardingModalImage background={ObStep16}></OnboardingModalImage>
                        </OnboardingModalRight>
                        <OnboardingModalButtons>
                            <OnboardingModalSkip
                            onClick={() => {
                                this.setState({onboarding_step: --this.state.onboarding_step})
                            }}>Back</OnboardingModalSkip>
                            <OnboardingModalNext
                            onClick={() => {
                                this.setState({onboarding_step: ++this.state.onboarding_step})
                            }}>Next <img
                                src={ChevronRightWhite} alt=""/></OnboardingModalNext>
                        </OnboardingModalButtons>
                        <OnboardingDots>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot></OnboardingDot>
                            <OnboardingDot active={true}></OnboardingDot>
                        </OnboardingDots>
                    </OnboardingModalStep>

                    <OnboardingModalStep open={this.state.onboarding_step == 17}>
                        <OnboardingSuccess>
                            <img src={CheckCircle} alt=""/>
                            <h3>Success!</h3>
                            <p>You have finished the Muze walkthrough and now you can begin teaching and learning with
                                Muze!</p>
                        <small>For more help and tutorials <a href="https://learnwithmuze.com/faqs/">visit our
                            FAQ</a>
                            </small>
                            <br/>
                        <button onClick={() => {
                            this.setState({onboarding_step: null})
                        }}>End <img
                                src={ChevronRightWhite} alt=""/></button>
                        </OnboardingSuccess>
                    </OnboardingModalStep>

                    <OnboardingModalStep open={this.state.onboarding_step == 18}>
                        <ExperienceReview>
                            <h2>How was your Muze experience?</h2>
                            <h3>Please take a moment to comment on your recent lesson.</h3>
                            <textarea onChange={(event) => {
                                this.setState({review_comments: event.target.value})
                            }}
                                      placeholder="Comments">
                                {this.state.review_comments}
                            </textarea>
                            <h3>What additional features would you like to see?</h3>
                            <textarea onChange={(event) => {
                                this.setState({review_features: event.target.value})
                            }}
                                      placeholder="Additional Features">
                                {this.state.review_features}
                            </textarea>
                            <h3>Please rate how likely you are to recommend Muze to others</h3>
                            <ExperienceRatingBar>
                                <ExperienceRatingItem onClick={() => {
                                    this.setState({selected_rating: 1})
                                }}
                                                      active={this.state.selected_rating === 1}>
                                    1
                                </ExperienceRatingItem>
                                <ExperienceRatingItem onClick={() => {
                                    this.setState({selected_rating: 2})
                                }}
                                                      active={this.state.selected_rating === 2}>
                                    2
                                </ExperienceRatingItem>
                                <ExperienceRatingItem onClick={() => {
                                    this.setState({selected_rating: 3})
                                }}
                                                      active={this.state.selected_rating === 3}>
                                    3
                                </ExperienceRatingItem>
                                <ExperienceRatingItem onClick={() => {
                                    this.setState({selected_rating: 4})
                                }}
                                                      active={this.state.selected_rating === 4}>
                                    4
                                </ExperienceRatingItem>
                                <ExperienceRatingItem onClick={() => {
                                    this.setState({selected_rating: 5})
                                }}
                                                      active={this.state.selected_rating === 5}>
                                    5
                                </ExperienceRatingItem>
                                <ExperienceRatingItem onClick={() => {
                                    this.setState({selected_rating: 6})
                                }}
                                                      active={this.state.selected_rating === 6}>
                                    6
                                </ExperienceRatingItem>
                                <ExperienceRatingItem onClick={() => {
                                    this.setState({selected_rating: 7})
                                }}
                                                      active={this.state.selected_rating === 7}>
                                    7
                                </ExperienceRatingItem>
                                <ExperienceRatingItem onClick={() => {
                                    this.setState({selected_rating: 8})
                                }}
                                                      active={this.state.selected_rating === 8}>
                                    8
                                </ExperienceRatingItem>
                                <ExperienceRatingItem onClick={() => {
                                    this.setState({selected_rating: 9})
                                }}
                                                      active={this.state.selected_rating === 9}>
                                    9
                                </ExperienceRatingItem>
                                <ExperienceRatingItem onClick={() => {
                                    this.setState({selected_rating: 10})
                                }}
                                                      active={this.state.selected_rating === 10}>
                                    10
                                </ExperienceRatingItem>
                            </ExperienceRatingBar>
                            <ExperienceRatingBarLegend>
                                <ExperienceRatingBarLegendItem>Not at all likely</ExperienceRatingBarLegendItem>
                                <ExperienceRatingBarLegendItem>Extremely likely</ExperienceRatingBarLegendItem>
                            </ExperienceRatingBarLegend>
                            <small>Find a bug? Please report bugs using the <a
                            onClick={() => {
                                this.setState({modal_open: null, onboarding_step: 20})
                            }}>contact us</a>
                                form from the settings
                                menu.
                            </small>
                            <ExperienceRatingButtons>
                            <a onClick={() => {
                                this.setState({onboarding_step: null})
                            }}>Skip</a>
                                <ExperienceRatingSubmitButton
                                    isDisabled={!this.state.review_comments}
                                    onClick={() => {
                                        if (this.state.review_comments) {
                                        api().post('/session/' + this.state.review_session_uuid + '/review', {
                                            rating: this.state.selected_rating,
                                            comments: this.state.review_comments,
                                            features: this.state.review_features
                                            }).then(() => {
                                            this.setState({
                                                selected_rating: null,
                                                review_comments: null,
                                                review_session_uuid: null,
                                                onboarding_step: null,
                                                review_features: null
                                            });
                                            toast.success('Success! Feedback saved!', {
                                                position: "top-right",
                                                autoClose: 5000,
                                                hideProgressBar: true,
                                                closeOnClick: true,
                                            });
                                        });
                                    } else {
                                        return false;
                                    }
                                }}>Submit <img src={ChevronRightWhite} alt=""/></ExperienceRatingSubmitButton>
                        </ExperienceRatingButtons>
                    </ExperienceReview>
                </OnboardingModalStep>

                    <OnboardingModalStep open={this.state.onboarding_step == 19}>
                        <OnboardingWelcome>
                            <img src={SparklesIcon} alt=""/>
                            <h3>Welcome to Muze!</h3>
                        <p>We are so excited to have you testing out our new product. Get started with this quick
                            3-5
                                minute walkthrough.</p>
                            <p>If you experience an issue, <a
                            onClick={() => {
                                this.setState({modal_open: null, onboarding_step: 20})
                            }}>contact us</a>
                                from the settings menu.</p>
                            <p>If you have other questions, please visit our <a target="_blank"
                                                                                href="https://learnwithmuze.com/faqs/">FAQ</a>
                            </p>
                            <br/>
                            <div>
                            <button onClick={() => {
                                this.setState({onboarding_step: null})
                            }}>Skip
                            </button>
                            <button onClick={() => {
                                this.setState({onboarding_step: 1})
                            }}>Begin Walkthrough <img
                                    src={ChevronRightWhite} alt=""/></button>
                            </div>
                        </OnboardingWelcome>
                    </OnboardingModalStep>

                    <OnboardingModalStep open={this.state.onboarding_step == 20}>
                        <ContactUsForm>
                            <h3>Contact Us</h3>
                            <ContactUsFormGroup className="half">
                                <label htmlFor="name">Name
                                </label>
                            <input onChange={(event) => {
                                this.setState({contact_us_first_name: event.target.value})
                            }}
                                       className="half" type="text" placeholder="First Name"/>
                            <input onChange={(event) => {
                                this.setState({contact_us_last_name: event.target.value})
                            }}
                                       className="half" type="text" placeholder="Last Name"/>
                            </ContactUsFormGroup>
                            <ContactUsFormGroup>
                                <label htmlFor="email">Email
                                    <small>*</small>
                                </label>
                            <input onChange={(event) => {
                                this.setState({contact_us_email: event.target.value})
                            }}
                                       type="text" placeholder="Email Address"/>
                            </ContactUsFormGroup>
                            <ContactUsFormGroup>
                                <label htmlFor="reason">Reason For Contact
                            </label>
                            <select onChange={(event) => {
                                this.setState({contact_us_reason: event.target.value})
                            }}
                                        name="reason" id="reason">
                                    <option value="">Choose your reason for contacting us</option>
                                    <option value="question">Question</option>
                                    <option value="bug">Bug</option>
                                </select>
                            </ContactUsFormGroup>
                            <ContactUsFormGroup>
                            <label htmlFor="email">Message
                                <small>*</small>
                            </label>
                            <textarea onChange={(event) => {
                                this.setState({contact_us_message: event.target.value})

                                    }}
                                    name="message"
                                    id="message"
                                    placeholder="Please describe your problem"
                                >
                                </textarea>
                            </ContactUsFormGroup>
                            <ContactUsFormGroup>
                                <label htmlFor="email">Device</label>
                            <select onChange={(event) => {
                                this.setState({contact_us_device: event.target.value})
                            }}
                                        name="device" id="device">
                                    <option value="">Choose which device you experienced this on</option>
                                    <option value="pc-chrome">PC - Chrome</option>
                                    <option value="pc-safari">PC - Safari</option>
                                    <option value="pc-ie">PC - IE</option>
                                    <option value="pc-firefox">PC - Firefox</option>
                                    <option value="mac-chrome">MAC - Chrome</option>
                                    <option value="mac-safari">MAC - Safari</option>
                                    <option value="mac-firefox">MAC - Firefox</option>
                                </select>
                            </ContactUsFormGroup>
                            <div className="button-wrapper">
                                <ContactUsFormButton onClick={() => {
                                    if (this.state.contact_us_email && this.state.contact_us_message) {
                                        api().post('/contact-us', {
                                            first_name: this.state.contact_us_first_name || '',
                                            last_name: this.state.contact_us_last_name || '',
                                            email: this.state.contact_us_email,
                                            reason: this.state.contact_us_reason,
                                            message: this.state.contact_us_message,
                                            device: this.state.contact_us_device || ''
                                        }).then((response) => {
                                            if (response.data.success) {
                                                this.setState({
                                                    onboarding_step: null,
                                                    contact_us_first_name: '',
                                                    contact_us_last_name: '',
                                                    contact_us_email: '',
                                                    contact_us_reason: '',
                                                    contact_us_message: '',
                                                    contact_us_device: '',
                                                });
                                                toast.success('Success! Contact Us submission sent!', {
                                                    position: "top-right",
                                                    autoClose: 5000,
                                                    hideProgressBar: true,
                                                    closeOnClick: true,
                                                });
                                            }
                                        });
                                    } else {
                                        return false;
                                    }
                                }}
                                                     isDisabled={!(this.state.contact_us_email && this.state.contact_us_message)}>Submit
                                    <img
                                        src={ChevronRightWhite} alt=""/></ContactUsFormButton>
                            </div>
                        </ContactUsForm>
                    </OnboardingModalStep>

                </OnboardingModal>
                <RecordingBar
                pauseStateText={this.state.recording_paused ? "PAUSED" : "RECORDING"}
                pauseButtonText={this.state.recording_paused ? "RESUME" : "STOP RECORDING"}
                    toggleRecording={this.toggleRecording}
                    time={this.state.recording_time}
                    open={this.state.recording_now}
                    show_recording_button={this.state.show_recording_button}
                ></RecordingBar>
                <RecordingNotice open={this.state.recording_pre}>
                    <RecordingNoticeIcon
                        src={RecordingNoticeIconImage}
                    ></RecordingNoticeIcon>
                    {this.state.recording_notice}
                </RecordingNotice>
                <GeneralNotice open={this.state.has_notice}
                               error={this.state.has_error}>{this.state.notice_text}</GeneralNotice>

            <AnnotationsWrapper>
                <ClipPlayer open={this.state.annotations_open}>
                    <ClipWrapper>
                        <ClipHeading>{this.state.clip_player_name}</ClipHeading>
                        <ClipClose onClick={() => {
                            this.closeClipAction();
                        }}>X</ClipClose>
                        <Clip>
                            <ClipVideo
                                autoplay="autoplay"
                                ref={"videoPlayer"}
                                disablePictureInPicture
                                onPlay={() => {
                                    // Skip broadcasting play/pause/seek events that we triggered
                                    // ourselves while applying a remote clip state (see the
                                    // ClipStatus listener) — otherwise they ping-pong endlessly.
                                    if (Date.now() < (this.suppressClipBroadcastUntil || 0)) return;
                                    if (this.props.lesson_id) {
                                        api().get("session/" + this.props.lesson_id + "/clips/" + this.state.clip_player_id + "/play")
                                    }
                                }}
                                onPause={() => {
                                    if (Date.now() < (this.suppressClipBroadcastUntil || 0)) return;
                                    if (this.props.lesson_id) {
                                        api().get("session/" + this.props.lesson_id + "/clips/" + this.state.clip_player_id + "/pause")
                                    }
                                }}
                                onSeeking={(ev) => {
                                    if (Date.now() < (this.suppressClipBroadcastUntil || 0)) return;
                                    var current_time = ev.target.currentTime;
                                    api().post("/session/" + this.props.lesson_id + "/clips/" + this.state.clip_player_id + "/seek", {
                                        'current_time': current_time
                                    });
                                    this.setState({
                                        last_current_time: current_time
                                    })
                                }}
                                controls="controls" type="video/mp4" src={this.state.clip_player_url}>
                            </ClipVideo>
                        </Clip>
                    </ClipWrapper>
                </ClipPlayer>
            </AnnotationsWrapper>

                <ToastContainer closeButton={false} autoClose={5000}/>
                <StudentFileUploadModal
                    open={this.state.studentUploadOpen}
                    instructors={this.state.studentInstructors}
                    onClose={() => this.setState({ studentUploadOpen: false })}
                    onUploaded={() => this.pullFiles()}
                />
                <StudentFileShareModal
                    open={this.state.studentShareOpen}
                    fileId={this.state.studentShareFileId}
                    instructors={this.state.studentInstructors}
                    onClose={() => this.setState({ studentShareOpen: false, studentShareFileId: null })}
                    onSaved={() => this.pullFiles()}
                />

        </>);
    }
}
